// // // // // import React, { useState, useEffect, useRef } from "react";
// // // // // import Slider from "react-slick";
// // // // // import "slick-carousel/slick/slick.css";
// // // // // import "slick-carousel/slick/slick-theme.css";
// // // // // import { FaEdit, FaSave, FaTrash } from "react-icons/fa";
// // // // // import axios from "axios";

// // // // // // ---------- Styles ----------
// // // // // const sectionStyle = {
// // // // //   maxWidth: "1350px",
// // // // //   margin: "0 auto",
// // // // //   border: "1px solid #bbb",
// // // // //   borderRadius: "10px",
// // // // //   marginTop: "50px",
// // // // // };
// // // // // const headerTextStyle = {
// // // // //   fontSize: "32px",
// // // // //   fontWeight: "700",
// // // // //   textAlign: "center",
// // // // //   marginBottom: "20px",
// // // // //   color: "rgb(177 93 198)",
// // // // // };
// // // // // const cardStyle = {
// // // // //   backgroundColor: "#fff",
// // // // //   borderRadius: "16px",
// // // // //   border: "2px solid #b15cd6",
// // // // //   padding: "30px 20px",
// // // // //   textAlign: "center",
// // // // //   margin: "0 10px",
// // // // //   width: "250px",
// // // // //   marginBottom: "20px",
// // // // //   position: "relative",
// // // // // };
// // // // // const imageStyle = {
// // // // //   width: "120px",
// // // // //   height: "120px",
// // // // //   borderRadius: "50%",
// // // // //   objectFit: "cover",
// // // // //   marginBottom: "20px",
// // // // //   border: "2px solid #b15dc6",
// // // // //   cursor: "pointer",
// // // // // };
// // // // // const nameStyle = { fontSize: "22px", fontWeight: "600", color: "#333", marginBottom: "6px" };
// // // // // const titleStyle = { fontSize: "16px", fontWeight: "500", color: "#b15dc6", marginBottom: "12px" };
// // // // // const descStyle = {
// // // // //   fontSize: "14px",
// // // // //   color: "#555",
// // // // //   lineHeight: "1.5",
// // // // //   whiteSpace: "pre-wrap",
// // // // //   overflow: "auto",
// // // // //   overflowWrap: "break-word",
// // // // //   wordBreak: "break-word",
// // // // //   maxHeight: "100px",
// // // // // };
// // // // // const inputStyle = {
// // // // //   marginBottom: "10px",
// // // // //   width: "100%",
// // // // //   padding: "5px",
// // // // //   fontSize: "14px",
// // // // // };
// // // // // const editButtonStyle = {
// // // // //   position: "absolute",
// // // // //   top: "5px",
// // // // //   right: "40px",
// // // // //   background: "transparent",
// // // // //   border: "none",
// // // // //   cursor: "pointer",
// // // // //   fontSize: "20px",
// // // // // };

// // // // // // ---------- Helper Function ----------
// // // // // const getValidImageUrl = (url) => {
// // // // //   if (!url) return "/default-image.jpg"; // fallback
// // // // //   try {
// // // // //     let decoded = decodeURIComponent(url);
// // // // //     if (decoded.startsWith("http://localhost:9000/caterings/http")) {
// // // // //       const parts = decoded.split("http://localhost:9000/caterings/");
// // // // //       decoded = `http://localhost:9000/caterings/${parts[parts.length - 1]}`;
// // // // //     }
// // // // //     return decoded;
// // // // //   } catch (err) {
// // // // //     console.error("Error parsing image URL:", err);
// // // // //     return "/default-image.jpg";
// // // // //   }
// // // // // };

// // // // // // ---------- Leadership Card Item ----------
// // // // // const LeadershipCardItem = ({ leader, onSaveEdit, onDelete }) => {
// // // // //   const [isEditing, setIsEditing] = useState(false);
// // // // //   const [editedData, setEditedData] = useState({ ...leader, imageFile: null });
// // // // //   const fileInputRef = useRef(null);

// // // // //   const handleEditToggle = () => {
// // // // //     if (isEditing) onSaveEdit(editedData);
// // // // //     setIsEditing(!isEditing);
// // // // //   };

// // // // //   const handleImageClick = () => {
// // // // //     if (isEditing) fileInputRef.current.click();
// // // // //   };

// // // // //   const handleImageChange = (e) => {
// // // // //     const file = e.target.files[0];
// // // // //     if (file) {
// // // // //       const reader = new FileReader();
// // // // //       reader.onloadend = () => {
// // // // //         setEditedData((prev) => ({ ...prev, image: reader.result, imageFile: file }));
// // // // //       };
// // // // //       reader.readAsDataURL(file);
// // // // //     }
// // // // //   };

// // // // //   return (
// // // // //     <div style={cardStyle}>
// // // // //       <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
// // // // //         <img
// // // // //           src={getValidImageUrl(editedData.image)}
// // // // //           alt={editedData.name}
// // // // //           style={imageStyle}
// // // // //           onClick={handleImageClick}
// // // // //         />
// // // // //         {isEditing && (
// // // // //           <input
// // // // //             type="file"
// // // // //             accept="image/*"
// // // // //             ref={fileInputRef}
// // // // //             onChange={handleImageChange}
// // // // //             style={{ display: "none" }}
// // // // //           />
// // // // //         )}
// // // // //         {isEditing ? (
// // // // //           <>
// // // // //             <input
// // // // //               style={inputStyle}
// // // // //               value={editedData.name}
// // // // //               onChange={(e) => setEditedData({ ...editedData, name: e.target.value })}
// // // // //             />
// // // // //             <input
// // // // //               style={inputStyle}
// // // // //               value={editedData.designation}
// // // // //               onChange={(e) => setEditedData({ ...editedData, designation: e.target.value })}
// // // // //             />
// // // // //             <textarea
// // // // //               style={inputStyle}
// // // // //               value={editedData.description}
// // // // //               onChange={(e) => setEditedData({ ...editedData, description: e.target.value })}
// // // // //             />
// // // // //           </>
// // // // //         ) : (
// // // // //           <>
// // // // //             <h3 style={nameStyle}>{editedData.name}</h3>
// // // // //             <p style={titleStyle}>{editedData.designation}</p>
// // // // //             <p style={descStyle}>{editedData.description}</p>
// // // // //           </>
// // // // //         )}
// // // // //         <button onClick={handleEditToggle} style={editButtonStyle}>
// // // // //           {isEditing ? <FaSave style={{ color: "blue" }} /> : <FaEdit style={{ color: "blue" }} />}
// // // // //         </button>
// // // // //         <button
// // // // //           onClick={() => onDelete(leader.teamId)}
// // // // //           style={{ ...editButtonStyle, marginRight: "-40px" }}
// // // // //         >
// // // // //           <FaTrash style={{ color: "red" }} />
// // // // //         </button>
// // // // //       </div>
// // // // //     </div>
// // // // //   );
// // // // // };

// // // // // // ---------- Main Leadership Component ----------
// // // // // const LeadershipCard = () => {
// // // // //   const [leadershipData, setLeadershipData] = useState([]);
// // // // //   const [isAddModalOpen, setIsAddModalOpen] = useState(false);
// // // // //   const [newMember, setNewMember] = useState({
// // // // //     name: "",
// // // // //     designation: "",
// // // // //     description: "",
// // // // //     imageFile: null,
// // // // //   });
// // // // //   const [vendorId, setVendorId] = useState(null);

// // // // //   useEffect(() => {
// // // // //     const storedVendorId = localStorage.getItem("vendorId");
// // // // //     if (storedVendorId) {
// // // // //       setVendorId(storedVendorId);
// // // // //       fetchTeamMembers(storedVendorId);
// // // // //     }
// // // // //   }, []);

// // // // //   const fetchTeamMembers = async (vendorId) => {
// // // // //     const token = localStorage.getItem("authToken");
// // // // //     if (!token) return alert("Auth token missing");

// // // // //     try {
// // // // //       const res = await axios.get(
// // // // //         `https://backend.maamaas.com/food/api/adminteam/getall/${vendorId}`,
// // // // //         { headers: { Authorization: `Bearer ${token}` } }
// // // // //       );

// // // // //       const formatted = res.data.map((m) => ({
// // // // //         ...m,
// // // // //         image: m.image ? getValidImageUrl(m.image) : "/default-image.jpg",
// // // // //       }));

// // // // //       setLeadershipData(formatted);
// // // // //     } catch (err) {
// // // // //       console.error(err);
// // // // //       // alert("Failed to fetch members");
// // // // //     }
// // // // //   };

// // // // //   const handleAddMember = async () => {
// // // // //     const token = localStorage.getItem("authToken");
// // // // //     const vendorIdNum = Number(localStorage.getItem("vendorId"));

// // // // //     if (!newMember.name || !newMember.designation || !newMember.description) {
// // // // //       return alert("Please fill all fields.");
// // // // //     }

// // // // //     const teamData = {
// // // // //       name: newMember.name,
// // // // //       designation: newMember.designation,
// // // // //       description: newMember.description,
// // // // //       vendorId: vendorIdNum,
// // // // //     };

// // // // //     const formData = new FormData();
// // // // //     if (newMember.imageFile instanceof File) formData.append("image", newMember.imageFile);
// // // // //     formData.append("teamData", new Blob([JSON.stringify(teamData)], { type: "application/json" }));

// // // // //     try {
// // // // //       await axios.post(
// // // // //         `https://backend.maamaas.com/food/api/adminteam/addteam/${vendorIdNum}`,
// // // // //         formData,
// // // // //         { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } }
// // // // //       );
// // // // //       alert("Team member added successfully!");
// // // // //       setNewMember({ name: "", designation: "", description: "", imageFile: null });
// // // // //       setIsAddModalOpen(false);
// // // // //       fetchTeamMembers(vendorIdNum);
// // // // //     } catch (err) {
// // // // //       console.error(err);
// // // // //       alert("Failed to add member. Check console.");
// // // // //     }
// // // // //   };

// // // // //   const handleSaveEdit = async (editedMember) => {
// // // // //     const token = localStorage.getItem("authToken");
// // // // //     const teamData = {
// // // // //       name: editedMember.name,
// // // // //       designation: editedMember.designation,
// // // // //       description: editedMember.description,
// // // // //       vendorId,
// // // // //     };

// // // // //     const formData = new FormData();
// // // // //     formData.append("teamData", new Blob([JSON.stringify(teamData)], { type: "application/json" }));
// // // // //     if (editedMember.imageFile instanceof File) formData.append("image", editedMember.imageFile);

// // // // //     try {
// // // // //       await axios.put(
// // // // //         `https://backend.maamaas.com/food/api/adminteam/editbyid/${editedMember.teamId}`,
// // // // //         formData,
// // // // //         { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } }
// // // // //       );
// // // // //       alert("Member updated successfully!");
// // // // //       fetchTeamMembers(vendorId);
// // // // //     } catch (err) {
// // // // //       console.error(err);
// // // // //       alert("Failed to update member. Check console.");
// // // // //     }
// // // // //   };

// // // // //   const handleDeleteMember = async (teamId) => {
// // // // //     if (!window.confirm("Are you sure to delete this member?")) return;
// // // // //     const token = localStorage.getItem("authToken");
// // // // //     try {
// // // // //       await axios.delete(
// // // // //         `https://backend.maamaas.com/food/api/adminteam/delete/${teamId}`,
// // // // //         { headers: { Authorization: `Bearer ${token}` } }
// // // // //       );
// // // // //       alert("Deleted successfully");
// // // // //       fetchTeamMembers(vendorId);
// // // // //     } catch (err) {
// // // // //       alert("Failed to delete member");
// // // // //     }
// // // // //   };

// // // // //   // ---------- Slider Settings ----------
// // // // //   const settings = {
// // // // //     dots: false,
// // // // //     infinite: leadershipData.length > 3,
// // // // //     speed: 500,
// // // // //     autoplay: true,
// // // // //     autoplaySpeed: 3000,
// // // // //     slidesToShow: Math.min(3, leadershipData.length),
// // // // //     slidesToScroll: 1,
// // // // //     responsive: [
// // // // //       { breakpoint: 1024, settings: { slidesToShow: Math.min(2, leadershipData.length) } },
// // // // //       { breakpoint: 600, settings: { slidesToShow: 1 } },
// // // // //     ],
// // // // //   };

// // // // //   return (
// // // // //     <section style={sectionStyle} className="our-team-data-code">
// // // // //       <div style={{ display: "flex", gap: "20px", justifyContent: "center", marginTop: "20px" }}>
// // // // //         <h1 style={headerTextStyle}>OUR TEAM</h1>
// // // // //         <button
// // // // //           onClick={() => setIsAddModalOpen(true)}
// // // // //           style={{
// // // // //             height: "35px",
// // // // //             borderRadius: "5px",
// // // // //             border: "none",
// // // // //             background: "#b15cd6",
// // // // //             color: "#fff",
// // // // //             fontWeight: "bold",
// // // // //             cursor: "pointer",
// // // // //             width: "80px",
// // // // //           }}
// // // // //         >
// // // // //           Add+
// // // // //         </button>
// // // // //       </div>

// // // // //       {isAddModalOpen && (
// // // // //         <div
// // // // //           style={{
// // // // //             position: "fixed",
// // // // //             top: 0,
// // // // //             left: 0,
// // // // //             right: 0,
// // // // //             bottom: 0,
// // // // //             background: "rgba(0,0,0,0.5)",
// // // // //             zIndex: 10,
// // // // //           }}
// // // // //         >
// // // // //           <div
// // // // //             style={{
// // // // //               maxWidth: "400px",
// // // // //               margin: "auto",
// // // // //               background: "white",
// // // // //               borderRadius: "8px",
// // // // //               padding: "20px",
// // // // //               position: "relative",
// // // // //               top: "50%",
// // // // //               transform: "translateY(-50%)",
// // // // //             }}
// // // // //           >
// // // // //             <h2 style={{ textAlign: "center", marginBottom: "20px" }}>Add New Team Member</h2>
// // // // //             <input
// // // // //               type="text"
// // // // //               placeholder="Name"
// // // // //               style={inputStyle}
// // // // //               value={newMember.name}
// // // // //               onChange={(e) => setNewMember({ ...newMember, name: e.target.value })}
// // // // //             />
// // // // //             <input
// // // // //               type="text"
// // // // //               placeholder="Designation"
// // // // //               style={inputStyle}
// // // // //               value={newMember.designation}
// // // // //               onChange={(e) => setNewMember({ ...newMember, designation: e.target.value })}
// // // // //             />
// // // // //             <textarea
// // // // //               placeholder="Description"
// // // // //               style={inputStyle}
// // // // //               value={newMember.description}
// // // // //               onChange={(e) => setNewMember({ ...newMember, description: e.target.value })}
// // // // //             />
// // // // //             <input
// // // // //               type="file"
// // // // //               accept="image/*"
// // // // //               onChange={(e) => setNewMember({ ...newMember, imageFile: e.target.files[0] })}
// // // // //               style={inputStyle}
// // // // //             />
// // // // //             <div style={{ textAlign: "center", marginTop: "20px" }}>
// // // // //               <button
// // // // //                 onClick={handleAddMember}
// // // // //                 style={{
// // // // //                   padding: "8px 16px",
// // // // //                   backgroundColor: "#4CAF50",
// // // // //                   color: "white",
// // // // //                   border: "none",
// // // // //                   borderRadius: "4px",
// // // // //                   cursor: "pointer",
// // // // //                 }}
// // // // //               >
// // // // //                 Add Member
// // // // //               </button>
// // // // //               <button
// // // // //                 onClick={() => setIsAddModalOpen(false)}
// // // // //                 style={{
// // // // //                   padding: "8px 16px",
// // // // //                   backgroundColor: "#f44336",
// // // // //                   color: "white",
// // // // //                   border: "none",
// // // // //                   borderRadius: "4px",
// // // // //                   cursor: "pointer",
// // // // //                   marginLeft: "10px",
// // // // //                 }}
// // // // //               >
// // // // //                 Cancel
// // // // //               </button>
// // // // //             </div>
// // // // //           </div>
// // // // //         </div>
// // // // //       )}

// // // // //       <Slider {...settings}>
// // // // //         {leadershipData.map((member) => (
// // // // //           <LeadershipCardItem
// // // // //             key={member.teamId}
// // // // //             leader={member}
// // // // //             onSaveEdit={handleSaveEdit}
// // // // //             onDelete={handleDeleteMember}
// // // // //           />
// // // // //         ))}
// // // // //       </Slider>
// // // // //     </section>
// // // // //   );
// // // // // };

// // // // // export default LeadershipCard;


// // // // import React, { useState, useEffect, useRef } from "react";
// // // // import Slider from "react-slick";
// // // // import "slick-carousel/slick/slick.css";
// // // // import "slick-carousel/slick/slick-theme.css";
// // // // import { FaEdit, FaSave, FaTrash, FaPlus, FaTimes, FaUser, FaCamera } from "react-icons/fa";
// // // // import axios from "axios";

// // // // // Helper Function
// // // // const getValidImageUrl = (url) => {
// // // //   if (!url) return "/default-image.jpg";
// // // //   try {
// // // //     let decoded = decodeURIComponent(url);
// // // //     if (decoded.startsWith("http://localhost:9000/caterings/http")) {
// // // //       const parts = decoded.split("http://localhost:9000/caterings/");
// // // //       decoded = `http://localhost:9000/caterings/${parts[parts.length - 1]}`;
// // // //     }
// // // //     return decoded;
// // // //   } catch (err) {
// // // //     console.error("Error parsing image URL:", err);
// // // //     return "/default-image.jpg";
// // // //   }
// // // // };

// // // // // Leadership Card Item Component
// // // // const LeadershipCardItem = ({ leader, onSaveEdit, onDelete }) => {
// // // //   const [isEditing, setIsEditing] = useState(false);
// // // //   const [editedData, setEditedData] = useState({ ...leader, imageFile: null });
// // // //   const fileInputRef = useRef(null);

// // // //   const handleEditToggle = () => {
// // // //     if (isEditing) {
// // // //       onSaveEdit(editedData);
// // // //     }
// // // //     setIsEditing(!isEditing);
// // // //   };

// // // //   const handleImageClick = () => {
// // // //     if (isEditing) fileInputRef.current?.click();
// // // //   };

// // // //   const handleImageChange = (e) => {
// // // //     const file = e.target.files[0];
// // // //     if (file) {
// // // //       const reader = new FileReader();
// // // //       reader.onloadend = () => {
// // // //         setEditedData((prev) => ({ ...prev, image: reader.result, imageFile: file }));
// // // //       };
// // // //       reader.readAsDataURL(file);
// // // //     }
// // // //   };

// // // //   return (
// // // //     <div className="team-card">
// // // //       <div className="card-content">
// // // //         {/* Image Section */}
// // // //         <div className="image-section" onClick={handleImageClick}>
// // // //           <img
// // // //             src={getValidImageUrl(editedData.image)}
// // // //             alt={editedData.name}
// // // //             className="member-image"
// // // //           />
// // // //           {isEditing && (
// // // //             <div className="image-overlay">
// // // //               <FaCamera className="camera-icon" />
// // // //               <span>Change Photo</span>
// // // //             </div>
// // // //           )}
// // // //           <input
// // // //             type="file"
// // // //             accept="image/*"
// // // //             ref={fileInputRef}
// // // //             onChange={handleImageChange}
// // // //             className="file-input"
// // // //           />
// // // //         </div>

// // // //         {/* Content Section */}
// // // //         <div className="content-section">
// // // //           {isEditing ? (
// // // //             <div className="edit-fields">
// // // //               <input
// // // //                 className="edit-input"
// // // //                 value={editedData.name}
// // // //                 onChange={(e) => setEditedData({ ...editedData, name: e.target.value })}
// // // //                 placeholder="Full Name"
// // // //               />
// // // //               <input
// // // //                 className="edit-input"
// // // //                 value={editedData.designation}
// // // //                 onChange={(e) => setEditedData({ ...editedData, designation: e.target.value })}
// // // //                 placeholder="Designation"
// // // //               />
// // // //               <textarea
// // // //                 className="edit-textarea"
// // // //                 value={editedData.description}
// // // //                 onChange={(e) => setEditedData({ ...editedData, description: e.target.value })}
// // // //                 placeholder="Description"
// // // //                 rows="3"
// // // //               />
// // // //             </div>
// // // //           ) : (
// // // //             <div className="display-content">
// // // //               <h3 className="member-name">{editedData.name}</h3>
// // // //               <p className="member-designation">{editedData.designation}</p>
// // // //               <p className="member-description">{editedData.description}</p>
// // // //             </div>
// // // //           )}
// // // //         </div>

// // // //         {/* Action Buttons */}
// // // //         <div className="action-buttons">
// // // //           <button 
// // // //             onClick={handleEditToggle} 
// // // //             className={`action-btn edit-btn ${isEditing ? 'saving' : ''}`}
// // // //             title={isEditing ? "Save Changes" : "Edit Member"}
// // // //           >
// // // //             {isEditing ? <FaSave /> : <FaEdit />}
// // // //           </button>
// // // //           <button
// // // //             onClick={() => onDelete(leader.teamId)}
// // // //             className="action-btn delete-btn"
// // // //             title="Delete Member"
// // // //           >
// // // //             <FaTrash />
// // // //           </button>
// // // //         </div>
// // // //       </div>

// // // //       <style jsx>{`
// // // //         .team-card {
// // // //           background: white;
// // // //           border-radius: 20px;
// // // //           padding: 25px;
// // // //           margin: 15px;
// // // //           box-shadow: 0 8px 30px rgba(177, 92, 214, 0.15);
// // // //           border: 2px solid #f0eaff;
// // // //           transition: all 0.3s ease;
// // // //           position: relative;
// // // //           overflow: hidden;
// // // //         }

// // // //         .team-card:hover {
// // // //           transform: translateY(-8px);
// // // //           box-shadow: 0 15px 40px rgba(177, 92, 214, 0.25);
// // // //           border-color: #b15cd6;
// // // //         }

// // // //         .card-content {
// // // //           display: flex;
// // // //           flex-direction: column;
// // // //           align-items: center;
// // // //           text-align: center;
// // // //         }

// // // //         /* Image Section */
// // // //         .image-section {
// // // //           position: relative;
// // // //           margin-bottom: 20px;
// // // //           cursor: ${isEditing ? 'pointer' : 'default'};
// // // //           border-radius: 50%;
// // // //           padding: 4px;
// // // //           background: linear-gradient(135deg, #b15cd6, #8a4fbf);
// // // //         }

// // // //         .member-image {
// // // //           width: 120px;
// // // //           height: 120px;
// // // //           border-radius: 50%;
// // // //           object-fit: cover;
// // // //           border: 4px solid white;
// // // //           transition: all 0.3s ease;
// // // //         }

// // // //         .image-section:hover .member-image {
// // // //           transform: ${isEditing ? 'scale(1.05)' : 'scale(1)'};
// // // //         }

// // // //         .image-overlay {
// // // //           position: absolute;
// // // //           top: 0;
// // // //           left: 0;
// // // //           right: 0;
// // // //           bottom: 0;
// // // //           background: rgba(177, 92, 214, 0.9);
// // // //           border-radius: 50%;
// // // //           display: flex;
// // // //           flex-direction: column;
// // // //           align-items: center;
// // // //           justify-content: center;
// // // //           color: white;
// // // //           opacity: 0;
// // // //           transition: all 0.3s ease;
// // // //         }

// // // //         .image-section:hover .image-overlay {
// // // //           opacity: 1;
// // // //         }

// // // //         .camera-icon {
// // // //           font-size: 1.5rem;
// // // //           margin-bottom: 5px;
// // // //         }

// // // //         .image-overlay span {
// // // //           font-size: 0.8rem;
// // // //           font-weight: 600;
// // // //         }

// // // //         .file-input {
// // // //           display: none;
// // // //         }

// // // //         /* Content Section */
// // // //         .content-section {
// // // //           width: 100%;
// // // //           margin-bottom: 20px;
// // // //         }

// // // //         .member-name {
// // // //           font-size: 1.3rem;
// // // //           font-weight: 700;
// // // //           color: #5d417b;
// // // //           margin: 0 0 8px 0;
// // // //           line-height: 1.2;
// // // //         }

// // // //         .member-designation {
// // // //           font-size: 1rem;
// // // //           font-weight: 600;
// // // //           color: #b15cd6;
// // // //           margin: 0 0 12px 0;
// // // //         }

// // // //         .member-description {
// // // //           font-size: 0.9rem;
// // // //           color: #666;
// // // //           line-height: 1.5;
// // // //           margin: 0;
// // // //           display: -webkit-box;
// // // //           -webkit-line-clamp: 3;
// // // //           -webkit-box-orient: vertical;
// // // //           overflow: hidden;
// // // //         }

// // // //         /* Edit Fields */
// // // //         .edit-fields {
// // // //           display: flex;
// // // //           flex-direction: column;
// // // //           gap: 10px;
// // // //         }

// // // //         .edit-input, .edit-textarea {
// // // //           padding: 10px 12px;
// // // //           border: 2px solid #e6dcf8;
// // // //           border-radius: 8px;
// // // //           font-size: 0.9rem;
// // // //           font-family: inherit;
// // // //           transition: all 0.3s ease;
// // // //           background: #fcfaff;
// // // //         }

// // // //         .edit-input:focus, .edit-textarea:focus {
// // // //           outline: none;
// // // //           border-color: #b15cd6;
// // // //           background: white;
// // // //           box-shadow: 0 0 0 3px rgba(177, 92, 214, 0.1);
// // // //         }

// // // //         .edit-textarea {
// // // //           resize: vertical;
// // // //           min-height: 80px;
// // // //         }

// // // //         /* Action Buttons */
// // // //         .action-buttons {
// // // //           display: flex;
// // // //           gap: 10px;
// // // //           margin-top: auto;
// // // //         }

// // // //         .action-btn {
// // // //           width: 40px;
// // // //           height: 40px;
// // // //           border-radius: 50%;
// // // //           border: none;
// // // //           display: flex;
// // // //           align-items: center;
// // // //           justify-content: center;
// // // //           cursor: pointer;
// // // //           transition: all 0.3s ease;
// // // //           font-size: 1rem;
// // // //         }

// // // //         .edit-btn {
// // // //           background: #f8f5ff;
// // // //           color: #8a4fbf;
// // // //           border: 2px solid #e6dcf8;
// // // //         }

// // // //         .edit-btn:hover, .edit-btn.saving {
// // // //           background: #b15cd6;
// // // //           color: white;
// // // //           border-color: #b15cd6;
// // // //           transform: scale(1.1);
// // // //         }

// // // //         .delete-btn {
// // // //           background: #fff5f5;
// // // //           color: #e53e3e;
// // // //           border: 2px solid #fed7d7;
// // // //         }

// // // //         .delete-btn:hover {
// // // //           background: #e53e3e;
// // // //           color: white;
// // // //           border-color: #e53e3e;
// // // //           transform: scale(1.1);
// // // //         }

// // // //         /* Responsive Design */
// // // //         @media (max-width: 768px) {
// // // //           .team-card {
// // // //             padding: 20px;
// // // //             margin: 10px;
// // // //           }

// // // //           .member-image {
// // // //             width: 100px;
// // // //             height: 100px;
// // // //           }

// // // //           .member-name {
// // // //             font-size: 1.1rem;
// // // //           }

// // // //           .member-designation {
// // // //             font-size: 0.9rem;
// // // //           }

// // // //           .member-description {
// // // //             font-size: 0.85rem;
// // // //           }
// // // //         }

// // // //         @media (max-width: 480px) {
// // // //           .team-card {
// // // //             padding: 15px;
// // // //             margin: 8px;
// // // //           }

// // // //           .member-image {
// // // //             width: 80px;
// // // //             height: 80px;
// // // //           }

// // // //           .action-btn {
// // // //             width: 35px;
// // // //             height: 35px;
// // // //             font-size: 0.9rem;
// // // //           }
// // // //         }
// // // //       `}</style>
// // // //     </div>
// // // //   );
// // // // };

// // // // // Main Leadership Component
// // // // const LeadershipCard = () => {
// // // //   const [leadershipData, setLeadershipData] = useState([]);
// // // //   const [isAddModalOpen, setIsAddModalOpen] = useState(false);
// // // //   const [newMember, setNewMember] = useState({
// // // //     name: "",
// // // //     designation: "",
// // // //     description: "",
// // // //     imageFile: null,
// // // //   });
// // // //   const [vendorId, setVendorId] = useState(null);
// // // //   const [isLoading, setIsLoading] = useState(false);

// // // //   useEffect(() => {
// // // //     const storedVendorId = localStorage.getItem("vendorId");
// // // //     if (storedVendorId) {
// // // //       setVendorId(storedVendorId);
// // // //       fetchTeamMembers(storedVendorId);
// // // //     }
// // // //   }, []);

// // // //   const fetchTeamMembers = async (vendorId) => {
// // // //     const token = localStorage.getItem("authToken");
// // // //     if (!token) return;

// // // //     setIsLoading(true);
// // // //     try {
// // // //       const res = await axios.get(
// // // //         `https://backend.maamaas.com/food/api/adminteam/getall/${vendorId}`,
// // // //         { headers: { Authorization: `Bearer ${token}` } }
// // // //       );

// // // //       const formatted = res.data.map((m) => ({
// // // //         ...m,
// // // //         image: m.image ? getValidImageUrl(m.image) : "/default-image.jpg",
// // // //       }));

// // // //       setLeadershipData(formatted);
// // // //     } catch (err) {
// // // //       console.error("Fetch error:", err);
// // // //     } finally {
// // // //       setIsLoading(false);
// // // //     }
// // // //   };

// // // //   const handleAddMember = async () => {
// // // //     const token = localStorage.getItem("authToken");
// // // //     const vendorIdNum = Number(localStorage.getItem("vendorId"));

// // // //     if (!newMember.name?.trim() || !newMember.designation?.trim() || !newMember.description?.trim()) {
// // // //       return alert("Please fill all fields.");
// // // //     }

// // // //     const teamData = {
// // // //       name: newMember.name.trim(),
// // // //       designation: newMember.designation.trim(),
// // // //       description: newMember.description.trim(),
// // // //       vendorId: vendorIdNum,
// // // //     };

// // // //     const formData = new FormData();
// // // //     if (newMember.imageFile instanceof File) formData.append("image", newMember.imageFile);
// // // //     formData.append("teamData", new Blob([JSON.stringify(teamData)], { type: "application/json" }));

// // // //     setIsLoading(true);
// // // //     try {
// // // //       await axios.post(
// // // //         `https://backend.maamaas.com/food/api/adminteam/addteam/${vendorIdNum}`,
// // // //         formData,
// // // //         { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } }
// // // //       );
// // // //       alert("Team member added successfully!");
// // // //       setNewMember({ name: "", designation: "", description: "", imageFile: null });
// // // //       setIsAddModalOpen(false);
// // // //       fetchTeamMembers(vendorIdNum);
// // // //     } catch (err) {
// // // //       console.error("Add error:", err);
// // // //       alert("Failed to add member. Please try again.");
// // // //     } finally {
// // // //       setIsLoading(false);
// // // //     }
// // // //   };

// // // //   const handleSaveEdit = async (editedMember) => {
// // // //     const token = localStorage.getItem("authToken");
// // // //     const teamData = {
// // // //       name: editedMember.name,
// // // //       designation: editedMember.designation,
// // // //       description: editedMember.description,
// // // //       vendorId,
// // // //     };

// // // //     const formData = new FormData();
// // // //     formData.append("teamData", new Blob([JSON.stringify(teamData)], { type: "application/json" }));
// // // //     if (editedMember.imageFile instanceof File) formData.append("image", editedMember.imageFile);

// // // //     setIsLoading(true);
// // // //     try {
// // // //       await axios.put(
// // // //         `https://backend.maamaas.com/food/api/adminteam/editbyid/${editedMember.teamId}`,
// // // //         formData,
// // // //         { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } }
// // // //       );
// // // //       alert("Member updated successfully!");
// // // //       fetchTeamMembers(vendorId);
// // // //     } catch (err) {
// // // //       console.error("Update error:", err);
// // // //       alert("Failed to update member. Please try again.");
// // // //     } finally {
// // // //       setIsLoading(false);
// // // //     }
// // // //   };

// // // //   const handleDeleteMember = async (teamId) => {
// // // //     if (!window.confirm("Are you sure you want to delete this team member?")) return;

// // // //     const token = localStorage.getItem("authToken");
// // // //     setIsLoading(true);
// // // //     try {
// // // //       await axios.delete(
// // // //         `https://backend.maamaas.com/food/api/adminteam/delete/${teamId}`,
// // // //         { headers: { Authorization: `Bearer ${token}` } }
// // // //       );
// // // //       alert("Member deleted successfully");
// // // //       fetchTeamMembers(vendorId);
// // // //     } catch (err) {
// // // //       alert("Failed to delete member");
// // // //     } finally {
// // // //       setIsLoading(false);
// // // //     }
// // // //   };

// // // //   // Slider Settings
// // // //   const settings = {
// // // //     dots: true,
// // // //     infinite: leadershipData.length > 3,
// // // //     speed: 500,
// // // //     autoplay: true,
// // // //     autoplaySpeed: 4000,
// // // //     slidesToShow: Math.min(4, leadershipData.length),
// // // //     slidesToScroll: 1,
// // // //     responsive: [
// // // //       { 
// // // //         breakpoint: 1200, 
// // // //         settings: { 
// // // //           slidesToShow: Math.min(3, leadershipData.length),
// // // //           dots: true
// // // //         } 
// // // //       },
// // // //       { 
// // // //         breakpoint: 768, 
// // // //         settings: { 
// // // //           slidesToShow: Math.min(2, leadershipData.length),
// // // //           dots: true
// // // //         } 
// // // //       },
// // // //       { 
// // // //         breakpoint: 480, 
// // // //         settings: { 
// // // //           slidesToShow: 1,
// // // //           dots: true
// // // //         } 
// // // //       },
// // // //     ],
// // // //   };

// // // //   return (
// // // //     <section className="leadership-section">
// // // //       {/* Header */}
// // // //       <div className="section-header">
// // // //         <div className="header-content">
// // // //           <div className="title-group">
// // // //             <h1 className="section-title">Meet Our Team</h1>
// // // //             <p className="section-subtitle">The passionate people behind our success</p>
// // // //           </div>
// // // //           <button
// // // //             onClick={() => setIsAddModalOpen(true)}
// // // //             className="add-member-btn"
// // // //             disabled={isLoading}
// // // //           >
// // // //             <FaPlus className="btn-icon" />
// // // //             Add Member
// // // //           </button>
// // // //         </div>
// // // //       </div>

// // // //       {/* Loading State */}
// // // //       {isLoading && (
// // // //         <div className="loading-overlay">
// // // //           <div className="loading-spinner"></div>
// // // //           <span>Loading team members...</span>
// // // //         </div>
// // // //       )}

// // // //       {/* Team Members Slider */}
// // // //       <div className="slider-container">
// // // //         {leadershipData.length > 0 ? (
// // // //           <Slider {...settings}>
// // // //             {leadershipData.map((member) => (
// // // //               <LeadershipCardItem
// // // //                 key={member.teamId}
// // // //                 leader={member}
// // // //                 onSaveEdit={handleSaveEdit}
// // // //                 onDelete={handleDeleteMember}
// // // //               />
// // // //             ))}
// // // //           </Slider>
// // // //         ) : (
// // // //           <div className="empty-state">
// // // //             <FaUser className="empty-icon" />
// // // //             <h3>No Team Members Yet</h3>
// // // //             <p>Add your first team member to get started</p>
// // // //             <button 
// // // //               onClick={() => setIsAddModalOpen(true)} 
// // // //               className="empty-state-btn"
// // // //             >
// // // //               <FaPlus /> Add First Member
// // // //             </button>
// // // //           </div>
// // // //         )}
// // // //       </div>

// // // //       {/* Add Member Modal */}
// // // //       {isAddModalOpen && (
// // // //         <div className="modal-overlay">
// // // //           <div className="modal-content">
// // // //             <div className="modal-header">
// // // //               <h2>Add New Team Member</h2>
// // // //               <button 
// // // //                 onClick={() => setIsAddModalOpen(false)} 
// // // //                 className="close-btn"
// // // //                 disabled={isLoading}
// // // //               >
// // // //                 <FaTimes />
// // // //               </button>
// // // //             </div>

// // // //             <div className="modal-body">
// // // //               <div className="form-group">
// // // //                 <label>Full Name *</label>
// // // //                 <input
// // // //                   type="text"
// // // //                   placeholder="Enter full name"
// // // //                   value={newMember.name}
// // // //                   onChange={(e) => setNewMember({ ...newMember, name: e.target.value })}
// // // //                   className="form-input"
// // // //                 />
// // // //               </div>

// // // //               <div className="form-group">
// // // //                 <label>Designation *</label>
// // // //                 <input
// // // //                   type="text"
// // // //                   placeholder="Enter designation"
// // // //                   value={newMember.designation}
// // // //                   onChange={(e) => setNewMember({ ...newMember, designation: e.target.value })}
// // // //                   className="form-input"
// // // //                 />
// // // //               </div>

// // // //               <div className="form-group">
// // // //                 <label>Description *</label>
// // // //                 <textarea
// // // //                   placeholder="Enter description"
// // // //                   value={newMember.description}
// // // //                   onChange={(e) => setNewMember({ ...newMember, description: e.target.value })}
// // // //                   className="form-textarea"
// // // //                   rows="4"
// // // //                 />
// // // //               </div>

// // // //               <div className="form-group">
// // // //                 <label>Profile Photo</label>
// // // //                 <div className="file-upload">
// // // //                   <input
// // // //                     type="file"
// // // //                     accept="image/*"
// // // //                     onChange={(e) => setNewMember({ ...newMember, imageFile: e.target.files[0] })}
// // // //                     className="file-input"
// // // //                     id="memberPhoto"
// // // //                   />
// // // //                   <label htmlFor="memberPhoto" className="file-label">
// // // //                     <FaCamera className="upload-icon" />
// // // //                     <span>{newMember.imageFile ? newMember.imageFile.name : "Choose Photo"}</span>
// // // //                   </label>
// // // //                 </div>
// // // //               </div>
// // // //             </div>

// // // //             <div className="modal-actions">
// // // //               <button
// // // //                 onClick={handleAddMember}
// // // //                 className="submit-btn"
// // // //                 disabled={isLoading || !newMember.name || !newMember.designation || !newMember.description}
// // // //               >
// // // //                 {isLoading ? "Adding..." : "Add Member"}
// // // //               </button>
// // // //               <button
// // // //                 onClick={() => setIsAddModalOpen(false)}
// // // //                 className="cancel-btn"
// // // //                 disabled={isLoading}
// // // //               >
// // // //                 Cancel
// // // //               </button>
// // // //             </div>
// // // //           </div>
// // // //         </div>
// // // //       )}

// // // //       <style jsx>{`
// // // //         .leadership-section {
// // // //           max-width: 1400px;
// // // //           margin: 50px auto;
// // // //           padding: 0 20px;
// // // //         }

// // // //         /* Header Styles */
// // // //         .section-header {
// // // //           background: linear-gradient(135deg, #fdfcff 0%, #f9f7ff 100%);
// // // //           border-radius: 20px;
// // // //           padding: 40px;
// // // //           margin-bottom: 40px;
// // // //           border: 1px solid #f0eaff;
// // // //           box-shadow: 0 8px 25px rgba(177, 92, 214, 0.1);
// // // //         }

// // // //         .header-content {
// // // //           display: flex;
// // // //           justify-content: space-between;
// // // //           align-items: center;
// // // //           max-width: 1200px;
// // // //           margin: 0 auto;
// // // //         }

// // // //         .title-group {
// // // //           text-align: left;
// // // //         }

// // // //         .section-title {
// // // //           font-size: clamp(2rem, 4vw, 3rem);
// // // //           font-weight: 800;
// // // //           color: #8a4fbf;
// // // //           margin: 0 0 8px 0;
// // // //           font-family: 'Playfair Display', serif;
// // // //         }

// // // //         .section-subtitle {
// // // //           font-size: 1.1rem;
// // // //           color: #666;
// // // //           margin: 0;
// // // //           font-weight: 400;
// // // //         }

// // // //         .add-member-btn {
// // // //           background: linear-gradient(135deg, #b15cd6, #8a4fbf);
// // // //           border: none;
// // // //           color: white;
// // // //           padding: 14px 28px;
// // // //           border-radius: 25px;
// // // //           cursor: pointer;
// // // //           display: flex;
// // // //           align-items: center;
// // // //           gap: 8px;
// // // //           font-weight: 600;
// // // //           transition: all 0.3s ease;
// // // //           box-shadow: 0 4px 15px rgba(177, 92, 214, 0.3);
// // // //           font-size: 1rem;
// // // //         }

// // // //         .add-member-btn:hover:not(:disabled) {
// // // //           transform: translateY(-2px);
// // // //           box-shadow: 0 6px 20px rgba(177, 92, 214, 0.4);
// // // //         }

// // // //         .add-member-btn:disabled {
// // // //           opacity: 0.6;
// // // //           cursor: not-allowed;
// // // //         }

// // // //         /* Slider Container */
// // // //         .slider-container {
// // // //           position: relative;
// // // //           margin: 0 -15px;
// // // //         }

// // // //         /* Empty State */
// // // //         .empty-state {
// // // //           text-align: center;
// // // //           padding: 60px 20px;
// // // //           background: white;
// // // //           border-radius: 20px;
// // // //           border: 2px dashed #e6dcf8;
// // // //         }

// // // //         .empty-icon {
// // // //           font-size: 4rem;
// // // //           color: #e6dcf8;
// // // //           margin-bottom: 20px;
// // // //         }

// // // //         .empty-state h3 {
// // // //           color: #5d417b;
// // // //           margin: 0 0 10px 0;
// // // //           font-size: 1.5rem;
// // // //         }

// // // //         .empty-state p {
// // // //           color: #888;
// // // //           margin: 0 0 25px 0;
// // // //         }

// // // //         .empty-state-btn {
// // // //           background: #b15cd6;
// // // //           color: white;
// // // //           border: none;
// // // //           padding: 12px 24px;
// // // //           border-radius: 20px;
// // // //           cursor: pointer;
// // // //           display: flex;
// // // //           align-items: center;
// // // //           gap: 8px;
// // // //           font-weight: 600;
// // // //           margin: 0 auto;
// // // //           transition: all 0.3s ease;
// // // //         }

// // // //         .empty-state-btn:hover {
// // // //           background: #8a4fbf;
// // // //           transform: translateY(-2px);
// // // //         }

// // // //         /* Modal Styles */
// // // //         .modal-overlay {
// // // //           position: fixed;
// // // //           top: 0;
// // // //           left: 0;
// // // //           right: 0;
// // // //           bottom: 0;
// // // //           background: rgba(0, 0, 0, 0.7);
// // // //           display: flex;
// // // //           align-items: center;
// // // //           justify-content: center;
// // // //           z-index: 1000;
// // // //           padding: 20px;
// // // //         }

// // // //         .modal-content {
// // // //           background: white;
// // // //           border-radius: 20px;
// // // //           padding: 0;
// // // //           max-width: 500px;
// // // //           width: 100%;
// // // //           max-height: 90vh;
// // // //           overflow-y: auto;
// // // //           box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);
// // // //         }

// // // //         .modal-header {
// // // //           display: flex;
// // // //           justify-content: space-between;
// // // //           align-items: center;
// // // //           padding: 30px 30px 20px;
// // // //           border-bottom: 1px solid #f0eaff;
// // // //         }

// // // //         .modal-header h2 {
// // // //           color: #5d417b;
// // // //           margin: 0;
// // // //           font-size: 1.5rem;
// // // //         }

// // // //         .close-btn {
// // // //           background: none;
// // // //           border: none;
// // // //           font-size: 1.2rem;
// // // //           color: #888;
// // // //           cursor: pointer;
// // // //           padding: 5px;
// // // //           border-radius: 50%;
// // // //           transition: all 0.3s ease;
// // // //         }

// // // //         .close-btn:hover {
// // // //           background: #f5f5f5;
// // // //           color: #333;
// // // //         }

// // // //         .modal-body {
// // // //           padding: 30px;
// // // //         }

// // // //         .form-group {
// // // //           margin-bottom: 20px;
// // // //         }

// // // //         .form-group label {
// // // //           display: block;
// // // //           margin-bottom: 8px;
// // // //           color: #5d417b;
// // // //           font-weight: 600;
// // // //           font-size: 0.9rem;
// // // //         }

// // // //         .form-input, .form-textarea {
// // // //           width: 100%;
// // // //           padding: 12px 16px;
// // // //           border: 2px solid #e6dcf8;
// // // //           border-radius: 10px;
// // // //           font-size: 1rem;
// // // //           font-family: inherit;
// // // //           transition: all 0.3s ease;
// // // //           background: #fcfaff;
// // // //         }

// // // //         .form-input:focus, .form-textarea:focus {
// // // //           outline: none;
// // // //           border-color: #b15cd6;
// // // //           background: white;
// // // //           box-shadow: 0 0 0 3px rgba(177, 92, 214, 0.1);
// // // //         }

// // // //         .form-textarea {
// // // //           resize: vertical;
// // // //           min-height: 100px;
// // // //         }

// // // //         .file-upload {
// // // //           position: relative;
// // // //         }

// // // //         .file-input {
// // // //           display: none;
// // // //         }

// // // //         .file-label {
// // // //           display: flex;
// // // //           align-items: center;
// // // //           gap: 10px;
// // // //           padding: 12px 16px;
// // // //           border: 2px dashed #e6dcf8;
// // // //           border-radius: 10px;
// // // //           cursor: pointer;
// // // //           transition: all 0.3s ease;
// // // //           background: #fcfaff;
// // // //         }

// // // //         .file-label:hover {
// // // //           border-color: #b15cd6;
// // // //           background: #f8f5ff;
// // // //         }

// // // //         .upload-icon {
// // // //           color: #b15cd6;
// // // //         }

// // // //         .modal-actions {
// // // //           display: flex;
// // // //           gap: 15px;
// // // //           padding: 20px 30px;
// // // //           border-top: 1px solid #f0eaff;
// // // //           background: #faf8ff;
// // // //           border-radius: 0 0 20px 20px;
// // // //         }

// // // //         .submit-btn, .cancel-btn {
// // // //           flex: 1;
// // // //           padding: 12px 20px;
// // // //           border: none;
// // // //           border-radius: 10px;
// // // //           font-weight: 600;
// // // //           cursor: pointer;
// // // //           transition: all 0.3s ease;
// // // //         }

// // // //         .submit-btn {
// // // //           background: #b15cd6;
// // // //           color: white;
// // // //         }

// // // //         .submit-btn:hover:not(:disabled) {
// // // //           background: #8a4fbf;
// // // //           transform: translateY(-1px);
// // // //         }

// // // //         .submit-btn:disabled {
// // // //           opacity: 0.6;
// // // //           cursor: not-allowed;
// // // //           transform: none;
// // // //         }

// // // //         .cancel-btn {
// // // //           background: #f8f5ff;
// // // //           color: #5d417b;
// // // //           border: 2px solid #e6dcf8;
// // // //         }

// // // //         .cancel-btn:hover:not(:disabled) {
// // // //           background: #f0eaff;
// // // //         }

// // // //         /* Loading Overlay */
// // // //         .loading-overlay {
// // // //           position: fixed;
// // // //           top: 0;
// // // //           left: 0;
// // // //           right: 0;
// // // //           bottom: 0;
// // // //           background: rgba(0, 0, 0, 0.7);
// // // //           display: flex;
// // // //           flex-direction: column;
// // // //           align-items: center;
// // // //           justify-content: center;
// // // //           color: white;
// // // //           z-index: 1000;
// // // //           gap: 15px;
// // // //         }

// // // //         .loading-spinner {
// // // //           width: 40px;
// // // //           height: 40px;
// // // //           border: 4px solid rgba(255, 255, 255, 0.3);
// // // //           border-top: 4px solid white;
// // // //           border-radius: 50%;
// // // //           animation: spin 1s linear infinite;
// // // //         }

// // // //         @keyframes spin {
// // // //           0% { transform: rotate(0deg); }
// // // //           100% { transform: rotate(360deg); }
// // // //         }

// // // //         /* Responsive Design */
// // // //         @media (max-width: 768px) {
// // // //           .leadership-section {
// // // //             padding: 0 15px;
// // // //             margin: 30px auto;
// // // //           }

// // // //           .section-header {
// // // //             padding: 30px 25px;
// // // //             margin-bottom: 30px;
// // // //           }

// // // //           .header-content {
// // // //             flex-direction: column;
// // // //             gap: 20px;
// // // //             text-align: center;
// // // //           }

// // // //           .title-group {
// // // //             text-align: center;
// // // //           }

// // // //           .modal-content {
// // // //             margin: 20px;
// // // //           }

// // // //           .modal-body {
// // // //             padding: 20px;
// // // //           }

// // // //           .modal-actions {
// // // //             flex-direction: column;
// // // //             gap: 10px;
// // // //           }
// // // //         }

// // // //         @media (max-width: 480px) {
// // // //           .section-header {
// // // //             padding: 25px 20px;
// // // //           }

// // // //           .modal-body {
// // // //             padding: 15px;
// // // //           }

// // // //           .modal-header {
// // // //             padding: 20px 20px 15px;
// // // //           }

// // // //           .modal-actions {
// // // //             padding: 15px 20px;
// // // //           }
// // // //         }

// // // //         /* Slick Carousel Customization */
// // // //         :global(.slick-slide) {
// // // //           padding: 10px;
// // // //         }

// // // //         :global(.slick-dots li button:before) {
// // // //           color: #b15cd6;
// // // //           font-size: 10px;
// // // //         }

// // // //         :global(.slick-dots li.slick-active button:before) {
// // // //           color: #8a4fbf;
// // // //         }

// // // //         :global(.slick-prev:before, .slick-next:before) {
// // // //           color: #b15cd6;
// // // //         }
// // // //       `}</style>
// // // //     </section>
// // // //   );
// // // // };

// // // // export default LeadershipCard;





// // // // import React, { useState, useEffect, useRef } from "react";
// // // // import Slider from "react-slick";
// // // // import "slick-carousel/slick/slick.css";
// // // // import "slick-carousel/slick/slick-theme.css";
// // // // import { FaEdit, FaSave, FaTrash } from "react-icons/fa";
// // // // import axios from "axios";

// // // // // ---------- Styles ----------
// // // // const sectionStyle = {
// // // //   maxWidth: "1350px",
// // // //   margin: "0 auto",
// // // //   border: "1px solid #bbb",
// // // //   borderRadius: "10px",
// // // //   marginTop: "50px",
// // // // };
// // // // const headerTextStyle = {
// // // //   fontSize: "32px",
// // // //   fontWeight: "700",
// // // //   textAlign: "center",
// // // //   marginBottom: "20px",
// // // //   color: "rgb(177 93 198)",
// // // // };
// // // // const cardStyle = {
// // // //   backgroundColor: "#fff",
// // // //   borderRadius: "16px",
// // // //   border: "2px solid #b15cd6",
// // // //   padding: "30px 20px",
// // // //   textAlign: "center",
// // // //   margin: "0 10px",
// // // //   width: "250px",
// // // //   marginBottom: "20px",
// // // //   position: "relative",
// // // // };
// // // // const imageStyle = {
// // // //   width: "120px",
// // // //   height: "120px",
// // // //   borderRadius: "50%",
// // // //   objectFit: "cover",
// // // //   marginBottom: "20px",
// // // //   border: "2px solid #b15dc6",
// // // //   cursor: "pointer",
// // // // };
// // // // const nameStyle = { fontSize: "22px", fontWeight: "600", color: "#333", marginBottom: "6px" };
// // // // const titleStyle = { fontSize: "16px", fontWeight: "500", color: "#b15dc6", marginBottom: "12px" };
// // // // const descStyle = {
// // // //   fontSize: "14px",
// // // //   color: "#555",
// // // //   lineHeight: "1.5",
// // // //   whiteSpace: "pre-wrap",
// // // //   overflow: "auto",
// // // //   overflowWrap: "break-word",
// // // //   wordBreak: "break-word",
// // // //   maxHeight: "100px",
// // // // };
// // // // const inputStyle = {
// // // //   marginBottom: "10px",
// // // //   width: "100%",
// // // //   padding: "5px",
// // // //   fontSize: "14px",
// // // // };
// // // // const editButtonStyle = {
// // // //   position: "absolute",
// // // //   top: "5px",
// // // //   right: "40px",
// // // //   background: "transparent",
// // // //   border: "none",
// // // //   cursor: "pointer",
// // // //   fontSize: "20px",
// // // // };

// // // // // ---------- Helper Function ----------
// // // // const getValidImageUrl = (url) => {
// // // //   if (!url) return "/default-image.jpg"; // fallback
// // // //   try {
// // // //     let decoded = decodeURIComponent(url);
// // // //     if (decoded.startsWith("http://localhost:9000/caterings/http")) {
// // // //       const parts = decoded.split("http://localhost:9000/caterings/");
// // // //       decoded = `http://localhost:9000/caterings/${parts[parts.length - 1]}`;
// // // //     }
// // // //     return decoded;
// // // //   } catch (err) {
// // // //     console.error("Error parsing image URL:", err);
// // // //     return "/default-image.jpg";
// // // //   }
// // // // };

// // // // // ---------- Leadership Card Item ----------
// // // // const LeadershipCardItem = ({ leader, onSaveEdit, onDelete }) => {
// // // //   const [isEditing, setIsEditing] = useState(false);
// // // //   const [editedData, setEditedData] = useState({ ...leader, imageFile: null });
// // // //   const fileInputRef = useRef(null);

// // // //   const handleEditToggle = () => {
// // // //     if (isEditing) onSaveEdit(editedData);
// // // //     setIsEditing(!isEditing);
// // // //   };

// // // //   const handleImageClick = () => {
// // // //     if (isEditing) fileInputRef.current.click();
// // // //   };

// // // //   const handleImageChange = (e) => {
// // // //     const file = e.target.files[0];
// // // //     if (file) {
// // // //       const reader = new FileReader();
// // // //       reader.onloadend = () => {
// // // //         setEditedData((prev) => ({ ...prev, image: reader.result, imageFile: file }));
// // // //       };
// // // //       reader.readAsDataURL(file);
// // // //     }
// // // //   };

// // // //   return (
// // // //     <div style={cardStyle}>
// // // //       <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
// // // //         <img
// // // //           src={getValidImageUrl(editedData.image)}
// // // //           alt={editedData.name}
// // // //           style={imageStyle}
// // // //           onClick={handleImageClick}
// // // //         />
// // // //         {isEditing && (
// // // //           <input
// // // //             type="file"
// // // //             accept="image/*"
// // // //             ref={fileInputRef}
// // // //             onChange={handleImageChange}
// // // //             style={{ display: "none" }}
// // // //           />
// // // //         )}
// // // //         {isEditing ? (
// // // //           <>
// // // //             <input
// // // //               style={inputStyle}
// // // //               value={editedData.name}
// // // //               onChange={(e) => setEditedData({ ...editedData, name: e.target.value })}
// // // //             />
// // // //             <input
// // // //               style={inputStyle}
// // // //               value={editedData.designation}
// // // //               onChange={(e) => setEditedData({ ...editedData, designation: e.target.value })}
// // // //             />
// // // //             <textarea
// // // //               style={inputStyle}
// // // //               value={editedData.description}
// // // //               onChange={(e) => setEditedData({ ...editedData, description: e.target.value })}
// // // //             />
// // // //           </>
// // // //         ) : (
// // // //           <>
// // // //             <h3 style={nameStyle}>{editedData.name}</h3>
// // // //             <p style={titleStyle}>{editedData.designation}</p>
// // // //             <p style={descStyle}>{editedData.description}</p>
// // // //           </>
// // // //         )}
// // // //         <button onClick={handleEditToggle} style={editButtonStyle}>
// // // //           {isEditing ? <FaSave style={{ color: "blue" }} /> : <FaEdit style={{ color: "blue" }} />}
// // // //         </button>
// // // //         <button
// // // //           onClick={() => onDelete(leader.teamId)}
// // // //           style={{ ...editButtonStyle, marginRight: "-40px" }}
// // // //         >
// // // //           <FaTrash style={{ color: "red" }} />
// // // //         </button>
// // // //       </div>
// // // //     </div>
// // // //   );
// // // // };

// // // // // ---------- Main Leadership Component ----------
// // // // const LeadershipCard = () => {
// // // //   const [leadershipData, setLeadershipData] = useState([]);
// // // //   const [isAddModalOpen, setIsAddModalOpen] = useState(false);
// // // //   const [newMember, setNewMember] = useState({
// // // //     name: "",
// // // //     designation: "",
// // // //     description: "",
// // // //     imageFile: null,
// // // //   });
// // // //   const [vendorId, setVendorId] = useState(null);

// // // //   useEffect(() => {
// // // //     const storedVendorId = localStorage.getItem("vendorId");
// // // //     if (storedVendorId) {
// // // //       setVendorId(storedVendorId);
// // // //       fetchTeamMembers(storedVendorId);
// // // //     }
// // // //   }, []);

// // // //   const fetchTeamMembers = async (vendorId) => {
// // // //     const token = localStorage.getItem("authToken");
// // // //     if (!token) return alert("Auth token missing");

// // // //     try {
// // // //       const res = await axios.get(
// // // //         `https://backend.maamaas.com/food/api/adminteam/getall/${vendorId}`,
// // // //         { headers: { Authorization: `Bearer ${token}` } }
// // // //       );

// // // //       const formatted = res.data.map((m) => ({
// // // //         ...m,
// // // //         image: m.image ? getValidImageUrl(m.image) : "/default-image.jpg",
// // // //       }));

// // // //       setLeadershipData(formatted);
// // // //     } catch (err) {
// // // //       console.error(err);
// // // //       // alert("Failed to fetch members");
// // // //     }
// // // //   };

// // // //   const handleAddMember = async () => {
// // // //     const token = localStorage.getItem("authToken");
// // // //     const vendorIdNum = Number(localStorage.getItem("vendorId"));

// // // //     if (!newMember.name || !newMember.designation || !newMember.description) {
// // // //       return alert("Please fill all fields.");
// // // //     }

// // // //     const teamData = {
// // // //       name: newMember.name,
// // // //       designation: newMember.designation,
// // // //       description: newMember.description,
// // // //       vendorId: vendorIdNum,
// // // //     };

// // // //     const formData = new FormData();
// // // //     if (newMember.imageFile instanceof File) formData.append("image", newMember.imageFile);
// // // //     formData.append("teamData", new Blob([JSON.stringify(teamData)], { type: "application/json" }));

// // // //     try {
// // // //       await axios.post(
// // // //         `https://backend.maamaas.com/food/api/adminteam/addteam/${vendorIdNum}`,
// // // //         formData,
// // // //         { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } }
// // // //       );
// // // //       alert("Team member added successfully!");
// // // //       setNewMember({ name: "", designation: "", description: "", imageFile: null });
// // // //       setIsAddModalOpen(false);
// // // //       fetchTeamMembers(vendorIdNum);
// // // //     } catch (err) {
// // // //       console.error(err);
// // // //       alert("Failed to add member. Check console.");
// // // //     }
// // // //   };

// // // //   const handleSaveEdit = async (editedMember) => {
// // // //     const token = localStorage.getItem("authToken");
// // // //     const teamData = {
// // // //       name: editedMember.name,
// // // //       designation: editedMember.designation,
// // // //       description: editedMember.description,
// // // //       vendorId,
// // // //     };

// // // //     const formData = new FormData();
// // // //     formData.append("teamData", new Blob([JSON.stringify(teamData)], { type: "application/json" }));
// // // //     if (editedMember.imageFile instanceof File) formData.append("image", editedMember.imageFile);

// // // //     try {
// // // //       await axios.put(
// // // //         `https://backend.maamaas.com/food/api/adminteam/editbyid/${editedMember.teamId}`,
// // // //         formData,
// // // //         { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } }
// // // //       );
// // // //       alert("Member updated successfully!");
// // // //       fetchTeamMembers(vendorId);
// // // //     } catch (err) {
// // // //       console.error(err);
// // // //       alert("Failed to update member. Check console.");
// // // //     }
// // // //   };

// // // //   const handleDeleteMember = async (teamId) => {
// // // //     if (!window.confirm("Are you sure to delete this member?")) return;
// // // //     const token = localStorage.getItem("authToken");
// // // //     try {
// // // //       await axios.delete(
// // // //         `https://backend.maamaas.com/food/api/adminteam/delete/${teamId}`,
// // // //         { headers: { Authorization: `Bearer ${token}` } }
// // // //       );
// // // //       alert("Deleted successfully");
// // // //       fetchTeamMembers(vendorId);
// // // //     } catch (err) {
// // // //       alert("Failed to delete member");
// // // //     }
// // // //   };

// // // //   // ---------- Slider Settings ----------
// // // //   const settings = {
// // // //     dots: false,
// // // //     infinite: leadershipData.length > 3,
// // // //     speed: 500,
// // // //     autoplay: true,
// // // //     autoplaySpeed: 3000,
// // // //     slidesToShow: Math.min(3, leadershipData.length),
// // // //     slidesToScroll: 1,
// // // //     responsive: [
// // // //       { breakpoint: 1024, settings: { slidesToShow: Math.min(2, leadershipData.length) } },
// // // //       { breakpoint: 600, settings: { slidesToShow: 1 } },
// // // //     ],
// // // //   };

// // // //   return (
// // // //     <section style={sectionStyle} className="our-team-data-code">
// // // //       <div style={{ display: "flex", gap: "20px", justifyContent: "center", marginTop: "20px" }}>
// // // //         <h1 style={headerTextStyle}>OUR TEAM</h1>
// // // //         <button
// // // //           onClick={() => setIsAddModalOpen(true)}
// // // //           style={{
// // // //             height: "35px",
// // // //             borderRadius: "5px",
// // // //             border: "none",
// // // //             background: "#b15cd6",
// // // //             color: "#fff",
// // // //             fontWeight: "bold",
// // // //             cursor: "pointer",
// // // //             width: "80px",
// // // //           }}
// // // //         >
// // // //           Add+
// // // //         </button>
// // // //       </div>

// // // //       {isAddModalOpen && (
// // // //         <div
// // // //           style={{
// // // //             position: "fixed",
// // // //             top: 0,
// // // //             left: 0,
// // // //             right: 0,
// // // //             bottom: 0,
// // // //             background: "rgba(0,0,0,0.5)",
// // // //             zIndex: 10,
// // // //           }}
// // // //         >
// // // //           <div
// // // //             style={{
// // // //               maxWidth: "400px",
// // // //               margin: "auto",
// // // //               background: "white",
// // // //               borderRadius: "8px",
// // // //               padding: "20px",
// // // //               position: "relative",
// // // //               top: "50%",
// // // //               transform: "translateY(-50%)",
// // // //             }}
// // // //           >
// // // //             <h2 style={{ textAlign: "center", marginBottom: "20px" }}>Add New Team Member</h2>
// // // //             <input
// // // //               type="text"
// // // //               placeholder="Name"
// // // //               style={inputStyle}
// // // //               value={newMember.name}
// // // //               onChange={(e) => setNewMember({ ...newMember, name: e.target.value })}
// // // //             />
// // // //             <input
// // // //               type="text"
// // // //               placeholder="Designation"
// // // //               style={inputStyle}
// // // //               value={newMember.designation}
// // // //               onChange={(e) => setNewMember({ ...newMember, designation: e.target.value })}
// // // //             />
// // // //             <textarea
// // // //               placeholder="Description"
// // // //               style={inputStyle}
// // // //               value={newMember.description}
// // // //               onChange={(e) => setNewMember({ ...newMember, description: e.target.value })}
// // // //             />
// // // //             <input
// // // //               type="file"
// // // //               accept="image/*"
// // // //               onChange={(e) => setNewMember({ ...newMember, imageFile: e.target.files[0] })}
// // // //               style={inputStyle}
// // // //             />
// // // //             <div style={{ textAlign: "center", marginTop: "20px" }}>
// // // //               <button
// // // //                 onClick={handleAddMember}
// // // //                 style={{
// // // //                   padding: "8px 16px",
// // // //                   backgroundColor: "#4CAF50",
// // // //                   color: "white",
// // // //                   border: "none",
// // // //                   borderRadius: "4px",
// // // //                   cursor: "pointer",
// // // //                 }}
// // // //               >
// // // //                 Add Member
// // // //               </button>
// // // //               <button
// // // //                 onClick={() => setIsAddModalOpen(false)}
// // // //                 style={{
// // // //                   padding: "8px 16px",
// // // //                   backgroundColor: "#f44336",
// // // //                   color: "white",
// // // //                   border: "none",
// // // //                   borderRadius: "4px",
// // // //                   cursor: "pointer",
// // // //                   marginLeft: "10px",
// // // //                 }}
// // // //               >
// // // //                 Cancel
// // // //               </button>
// // // //             </div>
// // // //           </div>
// // // //         </div>
// // // //       )}

// // // //       <Slider {...settings}>
// // // //         {leadershipData.map((member) => (
// // // //           <LeadershipCardItem
// // // //             key={member.teamId}
// // // //             leader={member}
// // // //             onSaveEdit={handleSaveEdit}
// // // //             onDelete={handleDeleteMember}
// // // //           />
// // // //         ))}
// // // //       </Slider>
// // // //     </section>
// // // //   );
// // // // };

// // // // export default LeadershipCard;










// // // import React, { useState, useEffect, useRef } from "react";
// // // import Slider from "react-slick";
// // // import "slick-carousel/slick/slick.css";
// // // import "slick-carousel/slick/slick-theme.css";
// // // import { FaEdit, FaSave, FaTrash, FaEllipsisV, FaPlus } from "react-icons/fa";
// // // import axios from "axios";
// // // import { Container, Row } from "react-bootstrap";

// // // // ---------- Helper Function ----------
// // // const getValidImageUrl = (url) => {
// // //   if (!url) return "/default-image.jpg";
// // //   try {
// // //     let decoded = decodeURIComponent(url);
// // //     if (decoded.startsWith("http://localhost:9000/caterings/http")) {
// // //       const parts = decoded.split("http://localhost:9000/caterings/");
// // //       decoded = `http://localhost:9000/caterings/${parts[parts.length - 1]}`;
// // //     }
// // //     return decoded;
// // //   } catch (err) {
// // //     console.error("Error parsing image URL:", err);
// // //     return "/default-image.jpg";
// // //   }
// // // };

// // // // ---------- Leadership Card Item ----------
// // // const LeadershipCardItem = ({ leader, onSaveEdit, onDelete }) => {
// // //   const [isEditing, setIsEditing] = useState(false);
// // //   const [editedData, setEditedData] = useState({ ...leader, imageFile: null });
// // //   const [showEditButtons, setShowEditButtons] = useState(false);
// // //   const [showThreeDots, setShowThreeDots] = useState(true);

// // //   const fileInputRef = useRef(null);
// // //   const threeDotsRef = useRef(null);
// // //   const editOptionsRef = useRef(null);
// // //   const timeoutRef = useRef(null);

// // //   // Click outside detection for each card
// // //   useEffect(() => {
// // //     const handleClickOutside = (event) => {
// // //       if (showEditButtons) {
// // //         const isEditOptionsClicked = editOptionsRef.current?.contains(event.target);
// // //         const isThreeDotsClicked = threeDotsRef.current?.contains(event.target);

// // //         if (!isEditOptionsClicked && !isThreeDotsClicked) {
// // //           setShowEditButtons(false);
// // //           setShowThreeDots(true);
// // //         }
// // //       }
// // //     };

// // //     document.addEventListener("mousedown", handleClickOutside);
// // //     return () => {
// // //       document.removeEventListener("mousedown", handleClickOutside);
// // //       if (timeoutRef.current) clearTimeout(timeoutRef.current);
// // //     };
// // //   }, [showEditButtons]);

// // //   // Auto-hide for each card
// // //   useEffect(() => {
// // //     if (showEditButtons) {
// // //       if (timeoutRef.current) clearTimeout(timeoutRef.current);
// // //       timeoutRef.current = setTimeout(() => {
// // //         setShowEditButtons(false);
// // //         setShowThreeDots(true);
// // //       }, 5000);
// // //     }
// // //   }, [showEditButtons]);

// // //   const handleThreeDotsClick = () => {
// // //     setShowThreeDots(false);
// // //     setShowEditButtons(true);
// // //   };

// // //   const handleEditClick = () => {
// // //     setShowEditButtons(false);
// // //     setIsEditing(true);
// // //   };

// // //   const handleEditToggle = () => {
// // //     if (isEditing) {
// // //       onSaveEdit(editedData);
// // //       setIsEditing(false);
// // //       setShowThreeDots(true);
// // //     } else {
// // //       setIsEditing(true);
// // //     }
// // //   };

// // //   const handleDeleteClick = () => {
// // //     setShowEditButtons(false);
// // //     onDelete(leader.teamId);
// // //   };

// // //   const handleImageClick = () => {
// // //     if (isEditing) fileInputRef.current.click();
// // //   };

// // //   const handleImageChange = (e) => {
// // //     const file = e.target.files[0];
// // //     if (file) {
// // //       const reader = new FileReader();
// // //       reader.onloadend = () => {
// // //         setEditedData((prev) => ({ ...prev, image: reader.result, imageFile: file }));
// // //       };
// // //       reader.readAsDataURL(file);
// // //     }
// // //   };

// // //   return (
// // //     <div style={{
// // //       backgroundColor: "white",
// // //       borderRadius: "20px",
// // //       padding: "15px",
// // //       textAlign: "center",
// // //       width: "200px",
// // //       height: "280px",
// // //       boxShadow: "0 4px 16px rgba(0,0,0,0.1)",
// // //       position: "relative",
// // //       border: "none",
// // //       display: "flex",
// // //       flexDirection: "column",
// // //       margin: "0 4px", // Added as backup margin
// // //     }}>
// // //       {/* Three Dots Button */}
// // //       {showThreeDots && (
// // //         <button
// // //           ref={threeDotsRef}
// // //           onClick={handleThreeDotsClick}
// // //           style={{
// // //             position: "absolute",
// // //             top: "8px",
// // //             right: "8px",
// // //             background: "transparent",
// // //             border: "none",
// // //             color: "#b15cd6",
// // //             cursor: "pointer",
// // //             fontSize: "14px",
// // //             padding: "4px",
// // //             borderRadius: "50%",
// // //             zIndex: 5,
// // //           }}
// // //           title="Options"
// // //         >
// // //           <FaEllipsisV />
// // //         </button>
// // //       )}

// // //       {/* Edit Options (Edit & Delete buttons) */}
// // //       {showEditButtons && (
// // //         <div
// // //           ref={editOptionsRef}
// // //           style={{
// // //             position: "absolute",
// // //             top: "8px",
// // //             right: "8px",
// // //             background: "white",
// // //             border: "1px solid #b15cd6",
// // //             borderRadius: "8px",
// // //             padding: "6px",
// // //             display: "flex",
// // //             flexDirection: "column",
// // //             gap: "4px",
// // //             boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
// // //             zIndex: 10,
// // //           }}
// // //         >
// // //           <button
// // //             onClick={handleEditClick}
// // //             style={{
// // //               background: "transparent",
// // //               border: "none",
// // //               color: "#b15cd6",
// // //               cursor: "pointer",
// // //               fontSize: "11px",
// // //               padding: "4px 8px",
// // //               borderRadius: "4px",
// // //               textAlign: "left",
// // //               fontWeight: "500",
// // //               display: "flex",
// // //               alignItems: "center",
// // //               gap: "4px",
// // //             }}
// // //           >
// // //             <FaEdit size={16} /> Edit
// // //           </button>
// // //           <button
// // //             onClick={handleDeleteClick}
// // //             style={{
// // //               background: "transparent",
// // //               border: "none",
// // //               color: "#e53e3e",
// // //               cursor: "pointer",
// // //               fontSize: "11px",
// // //               padding: "4px 8px",
// // //               borderRadius: "4px",
// // //               textAlign: "left",
// // //               fontWeight: "500",
// // //               display: "flex",
// // //               alignItems: "center",
// // //               gap: "4px",
// // //             }}
// // //           >
// // //             <FaTrash size={16} /> Delete
// // //           </button>
// // //         </div>
// // //       )}

// // //       <div style={{
// // //         display: "flex",
// // //         flexDirection: "column",
// // //         alignItems: "center",
// // //         height: "100%",
// // //         justifyContent: "space-between"
// // //       }}>
// // //         <img
// // //           src={getValidImageUrl(editedData.image)}
// // //           alt={editedData.name}
// // //           style={{
// // //             width: "70px",
// // //             height: "70px",
// // //             borderRadius: "50%",
// // //             objectFit: "cover",
// // //             marginBottom: "10px",
// // //             border: "2px solid #b15dc6",
// // //             cursor: isEditing ? "pointer" : "default",
// // //           }}
// // //           onClick={handleImageClick}
// // //         />
// // //         {isEditing && (
// // //           <input
// // //             type="file"
// // //             accept="image/*"
// // //             ref={fileInputRef}
// // //             onChange={handleImageChange}
// // //             style={{ display: "none" }}
// // //           />
// // //         )}

// // //         {isEditing ? (
// // //           <div style={{
// // //             width: "100%",
// // //             flex: 1,
// // //             display: "flex",
// // //             flexDirection: "column",
// // //             justifyContent: "space-between"
// // //           }}>
// // //             <div>
// // //               <input
// // //                 style={{
// // //                   marginBottom: "6px",
// // //                   width: "100%",
// // //                   padding: "6px",
// // //                   fontSize: "12px",
// // //                   border: "1px solid #ddd",
// // //                   borderRadius: "4px",
// // //                   fontFamily: "math",
// // //                 }}
// // //                 value={editedData.name}
// // //                 onChange={(e) => setEditedData({ ...editedData, name: e.target.value })}
// // //                 placeholder="Name"
// // //               />
// // //               <input
// // //                 style={{
// // //                   marginBottom: "6px",
// // //                   width: "100%",
// // //                   padding: "6px",
// // //                   fontSize: "12px",
// // //                   border: "1px solid #ddd",
// // //                   borderRadius: "4px",
// // //                   fontFamily: "math",
// // //                 }}
// // //                 value={editedData.designation}
// // //                 onChange={(e) => setEditedData({ ...editedData, designation: e.target.value })}
// // //                 placeholder="Designation"
// // //               />
// // //               <textarea
// // //                 style={{
// // //                   marginBottom: "6px",
// // //                   width: "100%",
// // //                   padding: "6px",
// // //                   fontSize: "11px",
// // //                   border: "1px solid #ddd",
// // //                   borderRadius: "4px",
// // //                   fontFamily: "math",
// // //                   height: "60px",
// // //                   resize: "none",
// // //                 }}
// // //                 value={editedData.description}
// // //                 onChange={(e) => setEditedData({ ...editedData, description: e.target.value })}
// // //                 placeholder="Description"
// // //               />
// // //             </div>
// // //             <button
// // //               onClick={handleEditToggle}
// // //               style={{
// // //                 background: "#b15cd6",
// // //                 color: "white",
// // //                 border: "none",
// // //                 padding: "6px 12px",
// // //                 borderRadius: "4px",
// // //                 cursor: "pointer",
// // //                 fontWeight: "bold",
// // //                 display: "flex",
// // //                 alignItems: "center",
// // //                 justifyContent: "center",
// // //                 gap: "4px",
// // //                 fontSize: "11px",
// // //                 width: "100%",
// // //               }}
// // //             >
// // //               <FaSave size={9} /> Save
// // //             </button>
// // //           </div>
// // //         ) : (
// // //           <div style={{
// // //             flex: 1,
// // //             display: "flex",
// // //             flexDirection: "column",
// // //             justifyContent: "space-between",
// // //             width: "100%"
// // //           }}>
// // //             <div>
// // //               <h3 style={{
// // //                 fontSize: "14px",
// // //                 fontWeight: "600",
// // //                 color: "#333",
// // //                 marginBottom: "4px",
// // //                 marginTop: "0px",
// // //                 lineHeight: "1.3",
// // //               }}>{editedData.name}</h3>
// // //               <p style={{
// // //                 fontSize: "12px",
// // //                 fontWeight: "500",
// // //                 color: "#b15dc6",
// // //                 marginBottom: "8px",
// // //                 marginTop: "0px",
// // //                 lineHeight: "1.3",
// // //               }}>{editedData.designation}</p>
// // //             </div>
// // //             <p style={{
// // //               fontSize: "11px",
// // //               color: "#555",
// // //               lineHeight: "1.3",
// // //               textAlign: "center",
// // //               margin: "0",
// // //               display: "-webkit-box",
// // //               WebkitLineClamp: "4",
// // //               WebkitBoxOrient: "vertical",
// // //               overflow: "hidden",
// // //               maxHeight: "52px",
// // //             }}>{editedData.description}</p>
// // //           </div>
// // //         )}
// // //       </div>
// // //     </div>
// // //   );
// // // };

// // // // ---------- Main Leadership Component ----------
// // // const LeadershipCard = () => {
// // //   const [leadershipData, setLeadershipData] = useState([]);
// // //   const [isAddModalOpen, setIsAddModalOpen] = useState(false);
// // //   const [newMember, setNewMember] = useState({
// // //     name: "",
// // //     designation: "",
// // //     description: "",
// // //     imageFile: null,
// // //   });
// // //   const [vendorId, setVendorId] = useState(null);

// // //   useEffect(() => {
// // //     const storedVendorId = localStorage.getItem("vendorId");
// // //     if (storedVendorId) {
// // //       setVendorId(storedVendorId);
// // //       fetchTeamMembers(storedVendorId);
// // //     }
// // //   }, []);

// // //   const fetchTeamMembers = async (vendorId) => {
// // //     const token = localStorage.getItem("authToken");
// // //     if (!token) return;

// // //     try {
// // //       const res = await axios.get(
// // //         `https://backend.maamaas.com/food/api/adminteam/getall/${vendorId}`,
// // //         { headers: { Authorization: `Bearer ${token}` } }
// // //       );

// // //       const formatted = res.data.map((m) => ({
// // //         ...m,
// // //         image: m.image ? getValidImageUrl(m.image) : "/default-image.jpg",
// // //       }));

// // //       setLeadershipData(formatted);
// // //     } catch (err) {
// // //       console.error(err);
// // //     }
// // //   };

// // //   const handleAddMember = async () => {
// // //     const token = localStorage.getItem("authToken");
// // //     const vendorIdNum = Number(localStorage.getItem("vendorId"));

// // //     if (!newMember.name || !newMember.designation || !newMember.description) {
// // //       return alert("Please fill all fields.");
// // //     }

// // //     const teamData = {
// // //       name: newMember.name,
// // //       designation: newMember.designation,
// // //       description: newMember.description,
// // //       vendorId: vendorIdNum,
// // //     };

// // //     const formData = new FormData();
// // //     if (newMember.imageFile instanceof File) formData.append("image", newMember.imageFile);
// // //     formData.append("teamData", new Blob([JSON.stringify(teamData)], { type: "application/json" }));

// // //     try {
// // //       await axios.post(
// // //         `https://backend.maamaas.com/food/api/adminteam/addteam/${vendorIdNum}`,
// // //         formData,
// // //         { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } }
// // //       );
// // //       alert("Team member added successfully!");
// // //       setNewMember({ name: "", designation: "", description: "", imageFile: null });
// // //       setIsAddModalOpen(false);
// // //       fetchTeamMembers(vendorIdNum);
// // //     } catch (err) {
// // //       console.error(err);
// // //       alert("Failed to add member. Check console.");
// // //     }
// // //   };

// // //   const handleSaveEdit = async (editedMember) => {
// // //     const token = localStorage.getItem("authToken");
// // //     const teamData = {
// // //       name: editedMember.name,
// // //       designation: editedMember.designation,
// // //       description: editedMember.description,
// // //       vendorId,
// // //     };

// // //     const formData = new FormData();
// // //     formData.append("teamData", new Blob([JSON.stringify(teamData)], { type: "application/json" }));
// // //     if (editedMember.imageFile instanceof File) formData.append("image", editedMember.imageFile);

// // //     try {
// // //       await axios.put(
// // //         `https://backend.maamaas.com/food/api/adminteam/editbyid/${editedMember.teamId}`,
// // //         formData,
// // //         { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } }
// // //       );
// // //       alert("Member updated successfully!");
// // //       fetchTeamMembers(vendorId);
// // //     } catch (err) {
// // //       console.error(err);
// // //       alert("Failed to update member. Check console.");
// // //     }
// // //   };

// // //   const handleDeleteMember = async (teamId) => {
// // //     if (!window.confirm("Are you sure to delete this member?")) return;
// // //     const token = localStorage.getItem("authToken");
// // //     try {
// // //       await axios.delete(
// // //         `https://backend.maamaas.com/food/api/adminteam/delete/${teamId}`,
// // //         { headers: { Authorization: `Bearer ${token}` } }
// // //       );
// // //       alert("Deleted successfully");
// // //       fetchTeamMembers(vendorId);
// // //     } catch (err) {
// // //       alert("Failed to delete member");
// // //     }
// // //   };

// // //   // ---------- Responsive Slider Settings ----------
// // //   // ---------- Responsive Slider Settings ----------
// // //   const settings = {
// // //     dots: false,
// // //     infinite: leadershipData.length > 1,
// // //     speed: 500,
// // //     autoplay: true,
// // //     autoplaySpeed: 3000,
// // //     slidesToShow: Math.min(4, leadershipData.length),
// // //     slidesToScroll: 1,
// // //     responsive: [
// // //       {
// // //         breakpoint: 1600, // 1200px - 1600px: 3 cards
// // //         settings: {
// // //           slidesToShow: Math.min(3, leadershipData.length),
// // //           infinite: leadershipData.length > 3,
// // //           slidesToScroll: 1,
// // //         }
// // //       },
// // //       {
// // //         breakpoint: 1200, // 900px - 1200px: 3 cards
// // //         settings: {
// // //           slidesToShow: Math.min(3, leadershipData.length),
// // //           infinite: leadershipData.length > 3,
// // //           slidesToScroll: 1,
// // //         }
// // //       },
// // //       {
// // //         breakpoint: 900, // 600px - 900px: 2 cards
// // //         settings: {
// // //           slidesToShow: Math.min(2, leadershipData.length),
// // //           infinite: leadershipData.length > 2,
// // //           slidesToScroll: 1,
// // //         }
// // //       },
// // //       {
// // //         breakpoint: 600, // Below 600px: 1 card
// // //         settings: {
// // //           slidesToShow: 1,
// // //           infinite: leadershipData.length > 1,
// // //           slidesToScroll: 1,
// // //         }
// // //       }
// // //     ],
// // //   };

// // //   return (
// // //     <Container fluid className="py-4">
// // //       <Row
// // //         style={{
// // //           border: "none",
// // //           borderRadius: "20px",
// // //           marginTop: "30px",
// // //           backgroundColor: "#b15dc6",
// // //           padding: "20px 0"
// // //         }}
// // //         className="align-items-center"
// // //       >
// // //         <div className="d-flex w-100 px-4 pt-3"
// // //           style={{
// // //             justifyContent: "space-around",
// // //             alignItems: "center"
// // //           }}
// // //         >
// // //           <h1
// // //             style={{
// // //               color: "#ffffff",
// // //               fontWeight: "bold",
// // //               textAlign: "center",
// // //               marginBottom: "10px",
// // //               fontSize: "26px",
// // //             }}
// // //           >
// // //             OUR TEAM
// // //           </h1>

// // //           <button
// // //             onClick={() => setIsAddModalOpen(true)}
// // //             style={buttonStyle}
// // //           >
            
// // //             Add+
// // //           </button>
// // //         </div>

// // //         {/* Team Members Carousel Section */}
// // //         <div
// // //           className="p-4"
// // //           style={{
// // //             backgroundColor: "white",
// // //             margin: "10px",
// // //             borderRadius: "20px",
// // //             width: "calc(100% - 20px)",
// // //           }}
// // //         >
// // //           {leadershipData.length === 0 ? (
// // //             <div style={{ textAlign: "center", padding: "40px", color: "#666" }}>
// // //               <p>No team members added yet. Click "Add+" to add your first team member.</p>
// // //             </div>
// // //           ) : (
// // //             <div style={{
// // //               padding: "0 20px", // Increased padding for better spacing
// // //             }}>
// // //               <Slider {...settings}>
// // //                 {leadershipData.map((member) => (
// // //                   <div key={member.teamId} style={{ padding: "0 12px" }}> {/* Increased padding for better gap */}
// // //                     <LeadershipCardItem
// // //                       leader={member}
// // //                       onSaveEdit={handleSaveEdit}
// // //                       onDelete={handleDeleteMember}
// // //                     />
// // //                   </div>
// // //                 ))}
// // //               </Slider>
// // //             </div>
// // //           )}
// // //         </div>
// // //       </Row>

// // //       {/* Add Member Modal */}
// // //       {isAddModalOpen && (
// // //         <div
// // //           style={{
// // //             position: "fixed",
// // //             top: 0,
// // //             left: 0,
// // //             right: 0,
// // //             bottom: 0,
// // //             background: "rgba(0,0,0,0.5)",
// // //             zIndex: 1000,
// // //             display: "flex",
// // //             alignItems: "center",
// // //             justifyContent: "center",
// // //           }}
// // //         >
// // //           <div
// // //             style={{
// // //               maxWidth: "500px",
// // //               width: "90%",
// // //               background: "white",
// // //               borderRadius: "20px",
// // //               padding: "30px",
// // //               position: "relative",
// // //               boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
// // //             }}
// // //           >
// // //             <h2 style={{
// // //               textAlign: "center",
// // //               marginBottom: "25px",
// // //               color: "#b15cd6",
// // //               fontWeight: "bold",
// // //               fontSize: "24px"
// // //             }}>
// // //               Add New Team Member
// // //             </h2>

// // //             <div style={{ marginBottom: "15px" }}>
// // //               <input
// // //                 type="text"
// // //                 placeholder="Name"
// // //                 style={modalInputStyle}
// // //                 value={newMember.name}
// // //                 onChange={(e) => setNewMember({ ...newMember, name: e.target.value })}
// // //               />
// // //             </div>

// // //             <div style={{ marginBottom: "15px" }}>
// // //               <input
// // //                 type="text"
// // //                 placeholder="Designation"
// // //                 style={modalInputStyle}
// // //                 value={newMember.designation}
// // //                 onChange={(e) => setNewMember({ ...newMember, designation: e.target.value })}
// // //               />
// // //             </div>

// // //             <div style={{ marginBottom: "15px" }}>
// // //               <textarea
// // //                 placeholder="Description"
// // //                 style={{ ...modalInputStyle, minHeight: "100px", resize: "vertical" }}
// // //                 value={newMember.description}
// // //                 onChange={(e) => setNewMember({ ...newMember, description: e.target.value })}
// // //               />
// // //             </div>

// // //             <div style={{ marginBottom: "20px" }}>
// // //               <input
// // //                 type="file"
// // //                 accept="image/*"
// // //                 onChange={(e) => setNewMember({ ...newMember, imageFile: e.target.files[0] })}
// // //                 style={modalInputStyle}
// // //               />
// // //             </div>

// // //             <div style={{ textAlign: "center", marginTop: "25px" }}>
// // //               <button
// // //                 onClick={handleAddMember}
// // //                 style={modalButtonStyle}
// // //               >
// // //                 Add Member
// // //               </button>
// // //               <button
// // //                 onClick={() => setIsAddModalOpen(false)}
// // //                 style={{ ...modalButtonStyle, backgroundColor: "#6c757d", marginLeft: "10px" }}
// // //               >
// // //                 Cancel
// // //               </button>
// // //             </div>
// // //           </div>
// // //         </div>
// // //       )}

// // //       <style>
// // //         {`
// // //     .hide-scrollbar::-webkit-scrollbar {
// // //       display: none;
// // //       width: 0;
// // //       height: 0;
// // //     }
    
// // //     .hide-scrollbar {
// // //       -ms-overflow-style: none;
// // //       scrollbar-width: none;
// // //     }

// // //     .slick-prev:before, .slick-next:before {
// // //       color: #b15cd6 !important;
// // //       font-size: 20px !important;
// // //       z-index:100000;
      
// // //     }

// // //     .slick-slide {
// // //       padding: 10px 0;
// // //       height: inherit;
// // //     }

// // //     .slick-list {
// // //       margin: 0 -12px; /* Match the padding in slide wrapper */
// // //       padding: 10px 0;
// // //       padding-left:25px;
// // //     }

// // //     .slick-track {
// // //       display: flex;
// // //       align-items: stretch;
// // //       margin-left: 0;
// // //       margin-right: 0;
// // //     }

// // //     /* Ensure consistent card spacing */
// // //     .slick-slide > div {
// // //       height: 100%;
// // //     }

// // //     /* Force gap between slides */
// // //     .slick-slide {
// // //       transition: transform 0.3s ease;
// // //     }

// // //     /* Custom styling for better visual separation */
// // //     .slick-slide:not(.slick-current) {
// // //       opacity: 0.95;
// // //     }
// // //   `}
// // //       </style>
// // //     </Container>
// // //   );
// // // };

// // // // Button Styles
// // // const buttonStyle = {
// // //   height: "35px",
// // //   borderRadius: "5px",
// // //   border: "none",
// // //   // background: "#b15cd6",
// // //   color: "#b15cd6",
// // //   fontWeight: "bold",
// // //   cursor: "pointer",
// // //   width: "80px",
// // //   marginLeft: "20px",
// // //   marginTop: "-10px",
// // //   display: "flex",
// // //   alignItems: "center",
// // //   justifyContent: "center",
// // //   gap: "5px",
// // // };

// // // const modalInputStyle = {
// // //   width: "100%",
// // //   padding: "12px",
// // //   fontSize: "14px",
// // //   border: "1px solid #ddd",
// // //   borderRadius: "8px",
// // //   fontFamily: "math",
// // //   backgroundColor: "#f5f4f4",
// // //   outline: "none",
// // // };

// // // const modalButtonStyle = {
// // //   padding: "12px 24px",
// // //   backgroundColor: "#b15cd6",
// // //   color: "white",
// // //   border: "none",
// // //   borderRadius: "8px",
// // //   cursor: "pointer",
// // //   fontWeight: "bold",
// // //   fontSize: "14px",
// // // };

// // // export default LeadershipCard;





// // import React, { useState, useEffect, useRef } from "react";
// // import Slider from "react-slick";
// // import "slick-carousel/slick/slick.css";
// // import "slick-carousel/slick/slick-theme.css";
// // import { FaEdit, FaSave, FaTrash, FaEllipsisV, FaPlus } from "react-icons/fa";
// // import axios from "axios";

// // // ---------- Helper Function ----------
// // const getValidImageUrl = (url) => {
// //   if (!url) return "/default-image.jpg";
// //   try {
// //     let decoded = decodeURIComponent(url);
// //     if (decoded.startsWith("http://localhost:9000/caterings/http")) {
// //       const parts = decoded.split("http://localhost:9000/caterings/");
// //       decoded = `http://localhost:9000/caterings/${parts[parts.length - 1]}`;
// //     }
// //     return decoded;
// //   } catch (err) {
// //     console.error("Error parsing image URL:", err);
// //     return "/default-image.jpg";
// //   }
// // };

// // // ---------- Leadership Card Item ----------
// // const LeadershipCardItem = ({ leader, onSaveEdit, onDelete }) => {
// //   const [isEditing, setIsEditing] = useState(false);
// //   const [editedData, setEditedData] = useState({ ...leader, imageFile: null });
// //   const [showEditButtons, setShowEditButtons] = useState(false);
// //   const [showThreeDots, setShowThreeDots] = useState(true);

// //   const fileInputRef = useRef(null);
// //   const threeDotsRef = useRef(null);
// //   const editOptionsRef = useRef(null);
// //   const timeoutRef = useRef(null);

// //   // Click outside detection for each card
// //   useEffect(() => {
// //     const handleClickOutside = (event) => {
// //       if (showEditButtons) {
// //         const isEditOptionsClicked = editOptionsRef.current?.contains(event.target);
// //         const isThreeDotsClicked = threeDotsRef.current?.contains(event.target);

// //         if (!isEditOptionsClicked && !isThreeDotsClicked) {
// //           setShowEditButtons(false);
// //           setShowThreeDots(true);
// //         }
// //       }
// //     };

// //     document.addEventListener("mousedown", handleClickOutside);
// //     return () => {
// //       document.removeEventListener("mousedown", handleClickOutside);
// //       if (timeoutRef.current) clearTimeout(timeoutRef.current);
// //     };
// //   }, [showEditButtons]);

// //   // Auto-hide for each card
// //   useEffect(() => {
// //     if (showEditButtons) {
// //       if (timeoutRef.current) clearTimeout(timeoutRef.current);
// //       timeoutRef.current = setTimeout(() => {
// //         setShowEditButtons(false);
// //         setShowThreeDots(true);
// //       }, 5000);
// //     }
// //   }, [showEditButtons]);

// //   const handleThreeDotsClick = () => {
// //     setShowThreeDots(false);
// //     setShowEditButtons(true);
// //   };

// //   const handleEditClick = () => {
// //     setShowEditButtons(false);
// //     setIsEditing(true);
// //   };

// //   const handleEditToggle = () => {
// //     if (isEditing) {
// //       onSaveEdit(editedData);
// //       setIsEditing(false);
// //       setShowThreeDots(true);
// //     } else {
// //       setIsEditing(true);
// //     }
// //   };

// //   const handleDeleteClick = () => {
// //     setShowEditButtons(false);
// //     onDelete(leader.teamId);
// //   };

// //   const handleImageClick = () => {
// //     if (isEditing) fileInputRef.current.click();
// //   };

// //   const handleImageChange = (e) => {
// //     const file = e.target.files[0];
// //     if (file) {
// //       const reader = new FileReader();
// //       reader.onloadend = () => {
// //         setEditedData((prev) => ({ ...prev, image: reader.result, imageFile: file }));
// //       };
// //       reader.readAsDataURL(file);
// //     }
// //   };

// //   return (
// //     <div style={{
// //       backgroundColor: "white",
// //       borderRadius: "20px",
// //       padding: "15px",
// //       textAlign: "center",
// //       width: window.innerWidth < 1300 ? "180px" : "200px",
// //       height: "280px",
// //       boxShadow: "0 4px 16px rgba(0,0,0,0.1)",
// //       position: "relative",
// //       border: "none",
// //       display: "flex",
// //       flexDirection: "column",
// //       margin: "0 4px",
// //     }}>
// //       {/* Three Dots Button */}
// //       {showThreeDots && (
// //         <button
// //           ref={threeDotsRef}
// //           onClick={handleThreeDotsClick}
// //           style={{
// //             position: "absolute",
// //             top: "8px",
// //             right: "8px",
// //             background: "transparent",
// //             border: "none",
// //             color: "#b15cd6",
// //             cursor: "pointer",
// //             fontSize: "14px",
// //             padding: "4px",
// //             borderRadius: "50%",
// //             zIndex: 5,
// //           }}
// //           title="Options"
// //         >
// //           <FaEllipsisV />
// //         </button>
// //       )}

// //       {/* Edit Options (Edit & Delete buttons) */}
// //       {showEditButtons && (
// //         <div
// //           ref={editOptionsRef}
// //           style={{
// //             position: "absolute",
// //             top: "8px",
// //             right: "8px",
// //             background: "white",
// //             border: "1px solid #b15cd6",
// //             borderRadius: "8px",
// //             padding: "6px",
// //             display: "flex",
// //             flexDirection: "column",
// //             gap: "4px",
// //             boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
// //             zIndex: 10,
// //           }}
// //         >
// //           <button
// //             onClick={handleEditClick}
// //             style={{
// //               background: "transparent",
// //               border: "none",
// //               color: "#b15cd6",
// //               cursor: "pointer",
// //               fontSize: "11px",
// //               padding: "4px 8px",
// //               borderRadius: "4px",
// //               textAlign: "left",
// //               fontWeight: "500",
// //               display: "flex",
// //               alignItems: "center",
// //               gap: "4px",
// //             }}
// //           >
// //             <FaEdit size={16} /> Edit
// //           </button>
// //           <button
// //             onClick={handleDeleteClick}
// //             style={{
// //               background: "transparent",
// //               border: "none",
// //               color: "#e53e3e",
// //               cursor: "pointer",
// //               fontSize: "11px",
// //               padding: "4px 8px",
// //               borderRadius: "4px",
// //               textAlign: "left",
// //               fontWeight: "500",
// //               display: "flex",
// //               alignItems: "center",
// //               gap: "4px",
// //             }}
// //           >
// //             <FaTrash size={16} /> Delete
// //           </button>
// //         </div>
// //       )}

// //       <div style={{
// //         display: "flex",
// //         flexDirection: "column",
// //         alignItems: "center",
// //         height: "100%",
// //         justifyContent: "space-between"
// //       }}>
// //         <img
// //           src={getValidImageUrl(editedData.image)}
// //           alt={editedData.name}
// //           style={{
// //             width: "70px",
// //             height: "70px",
// //             borderRadius: "50%",
// //             objectFit: "cover",
// //             marginBottom: "10px",
// //             border: "2px solid #b15dc6",
// //             cursor: isEditing ? "pointer" : "default",
// //           }}
// //           onClick={handleImageClick}
// //         />
// //         {isEditing && (
// //           <input
// //             type="file"
// //             accept="image/*"
// //             ref={fileInputRef}
// //             onChange={handleImageChange}
// //             style={{ display: "none" }}
// //           />
// //         )}

// //         {isEditing ? (
// //           <div style={{
// //             width: "100%",
// //             flex: 1,
// //             display: "flex",
// //             flexDirection: "column",
// //             justifyContent: "space-between"
// //           }}>
// //             <div>
// //               <input
// //                 style={{
// //                   marginBottom: "6px",
// //                   width: "100%",
// //                   padding: "6px",
// //                   fontSize: "12px",
// //                   border: "1px solid #ddd",
// //                   borderRadius: "4px",
// //                   fontFamily: "math",
// //                 }}
// //                 value={editedData.name}
// //                 onChange={(e) => setEditedData({ ...editedData, name: e.target.value })}
// //                 placeholder="Name"
// //               />
// //               <input
// //                 style={{
// //                   marginBottom: "6px",
// //                   width: "100%",
// //                   padding: "6px",
// //                   fontSize: "12px",
// //                   border: "1px solid #ddd",
// //                   borderRadius: "4px",
// //                   fontFamily: "math",
// //                 }}
// //                 value={editedData.designation}
// //                 onChange={(e) => setEditedData({ ...editedData, designation: e.target.value })}
// //                 placeholder="Designation"
// //               />
// //               <textarea
// //                 style={{
// //                   marginBottom: "6px",
// //                   width: "100%",
// //                   padding: "6px",
// //                   fontSize: "11px",
// //                   border: "1px solid #ddd",
// //                   borderRadius: "4px",
// //                   fontFamily: "math",
// //                   height: "60px",
// //                   resize: "none",
// //                 }}
// //                 value={editedData.description}
// //                 onChange={(e) => setEditedData({ ...editedData, description: e.target.value })}
// //                 placeholder="Description"
// //               />
// //             </div>
// //             <button
// //               onClick={handleEditToggle}
// //               style={{
// //                 background: "#b15cd6",
// //                 color: "white",
// //                 border: "none",
// //                 padding: "6px 12px",
// //                 borderRadius: "4px",
// //                 cursor: "pointer",
// //                 fontWeight: "bold",
// //                 display: "flex",
// //                 alignItems: "center",
// //                 justifyContent: "center",
// //                 gap: "4px",
// //                 fontSize: "11px",
// //                 width: "100%",
// //               }}
// //             >
// //               <FaSave size={9} /> Save
// //             </button>
// //           </div>
// //         ) : (
// //           <div style={{
// //             flex: 1,
// //             display: "flex",
// //             flexDirection: "column",
// //             justifyContent: "space-between",
// //             width: "100%"
// //           }}>
// //             <div>
// //               <h3 style={{
// //                 fontSize: "14px",
// //                 fontWeight: "600",
// //                 color: "#333",
// //                 marginBottom: "4px",
// //                 marginTop: "0px",
// //                 lineHeight: "1.3",
// //               }}>{editedData.name}</h3>
// //               <p style={{
// //                 fontSize: "12px",
// //                 fontWeight: "500",
// //                 color: "#b15dc6",
// //                 marginBottom: "8px",
// //                 marginTop: "0px",
// //                 lineHeight: "1.3",
// //               }}>{editedData.designation}</p>
// //             </div>
// //             <p style={{
// //               fontSize: "11px",
// //               color: "#555",
// //               lineHeight: "1.3",
// //               textAlign: "center",
// //               margin: "0",
// //               display: "-webkit-box",
// //               WebkitLineClamp: "4",
// //               WebkitBoxOrient: "vertical",
// //               overflow: "hidden",
// //               maxHeight: "52px",
// //             }}>{editedData.description}</p>
// //           </div>
// //         )}
// //       </div>
// //     </div>
// //   );
// // };

// // // ---------- Main Leadership Component ----------
// // const LeadershipCard = () => {
// //   const [leadershipData, setLeadershipData] = useState([]);
// //   const [isAddModalOpen, setIsAddModalOpen] = useState(false);
// //   const [newMember, setNewMember] = useState({
// //     name: "",
// //     designation: "",
// //     description: "",
// //     imageFile: null,
// //   });
// //   const [vendorId, setVendorId] = useState(null);

// //   useEffect(() => {
// //     const storedVendorId = localStorage.getItem("vendorId");
// //     if (storedVendorId) {
// //       setVendorId(storedVendorId);
// //       fetchTeamMembers(storedVendorId);
// //     }
// //   }, []);

// //   const fetchTeamMembers = async (vendorId) => {
// //     const token = localStorage.getItem("authToken");
// //     if (!token) return;

// //     try {
// //       const res = await axios.get(
// //         `https://backend.maamaas.com/food/api/adminteam/getall/${vendorId}`,
// //         { headers: { Authorization: `Bearer ${token}` } }
// //       );

// //       const formatted = res.data.map((m) => ({
// //         ...m,
// //         image: m.image ? getValidImageUrl(m.image) : "/default-image.jpg",
// //       }));

// //       setLeadershipData(formatted);
// //     } catch (err) {
// //       console.error(err);
// //     }
// //   };

// //   const handleAddMember = async () => {
// //     const token = localStorage.getItem("authToken");
// //     const vendorIdNum = Number(localStorage.getItem("vendorId"));

// //     if (!newMember.name || !newMember.designation || !newMember.description) {
// //       return alert("Please fill all fields.");
// //     }

// //     const teamData = {
// //       name: newMember.name,
// //       designation: newMember.designation,
// //       description: newMember.description,
// //       vendorId: vendorIdNum,
// //     };

// //     const formData = new FormData();
// //     if (newMember.imageFile instanceof File) formData.append("image", newMember.imageFile);
// //     formData.append("teamData", new Blob([JSON.stringify(teamData)], { type: "application/json" }));

// //     try {
// //       await axios.post(
// //         `https://backend.maamaas.com/food/api/adminteam/addteam/${vendorIdNum}`,
// //         formData,
// //         { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } }
// //       );
// //       alert("Team member added successfully!");
// //       setNewMember({ name: "", designation: "", description: "", imageFile: null });
// //       setIsAddModalOpen(false);
// //       fetchTeamMembers(vendorIdNum);
// //     } catch (err) {
// //       console.error(err);
// //       alert("Failed to add member. Check console.");
// //     }
// //   };

// //   const handleSaveEdit = async (editedMember) => {
// //     const token = localStorage.getItem("authToken");
// //     const teamData = {
// //       name: editedMember.name,
// //       designation: editedMember.designation,
// //       description: editedMember.description,
// //       vendorId,
// //     };

// //     const formData = new FormData();
// //     formData.append("teamData", new Blob([JSON.stringify(teamData)], { type: "application/json" }));
// //     if (editedMember.imageFile instanceof File) formData.append("image", editedMember.imageFile);

// //     try {
// //       await axios.put(
// //         `https://backend.maamaas.com/food/api/adminteam/editbyid/${editedMember.teamId}`,
// //         formData,
// //         { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } }
// //       );
// //       alert("Member updated successfully!");
// //       fetchTeamMembers(vendorId);
// //     } catch (err) {
// //       console.error(err);
// //       alert("Failed to update member. Check console.");
// //     }
// //   };

// //   const handleDeleteMember = async (teamId) => {
// //     if (!window.confirm("Are you sure to delete this member?")) return;
// //     const token = localStorage.getItem("authToken");
// //     try {
// //       await axios.delete(
// //         `https://backend.maamaas.com/food/api/adminteam/delete/${teamId}`,
// //         { headers: { Authorization: `Bearer ${token}` } }
// //       );
// //       alert("Deleted successfully");
// //       fetchTeamMembers(vendorId);
// //     } catch (err) {
// //       alert("Failed to delete member");
// //     }
// //   };

// //   // ---------- Slider Settings (without arrows) ----------
// //   const settings = {
// //     dots: false,
// //     infinite: leadershipData.length > 1,
// //     speed: 500,
// //     autoplay: true,
// //     autoplaySpeed: 3000,
// //     slidesToShow: Math.min(4, leadershipData.length),
// //     slidesToScroll: 1,
// //     arrows: false, // Remove forward/next buttons
// //     responsive: [
// //       {
// //         breakpoint: 1600,
// //         settings: {
// //           slidesToShow: Math.min(3, leadershipData.length),
// //           infinite: leadershipData.length > 3,
// //           slidesToScroll: 1,
// //           arrows: false,
// //         }
// //       },
// //       {
// //         breakpoint: 1200,
// //         settings: {
// //           slidesToShow: Math.min(3, leadershipData.length),
// //           infinite: leadershipData.length > 3,
// //           slidesToScroll: 1,
// //           arrows: false,
// //         }
// //       },
// //       {
// //         breakpoint: 900,
// //         settings: {
// //           slidesToShow: Math.min(2, leadershipData.length),
// //           infinite: leadershipData.length > 2,
// //           slidesToScroll: 1,
// //           arrows: false,
// //         }
// //       },
// //       {
// //         breakpoint: 600,
// //         settings: {
// //           slidesToShow: 1,
// //           infinite: leadershipData.length > 1,
// //           slidesToScroll: 1,
// //           arrows: false,
// //         }
// //       }
// //     ],
// //   };

// //   return (
// //     <div style={{
// //       padding: "16px 0",
// //       width: "100%",
// //     }}>
// //       <div style={{
// //         border: "none",
// //         borderRadius: "20px",
// //         marginTop: "30px",
// //         backgroundColor: "#b15dc6",
// //         padding: "20px 0"
// //       }}>
// //         <div style={{
// //           display: "flex",
// //           width: "100%",
// //           padding: "0 16px",
// //           paddingTop: "12px",
// //           justifyContent: "space-around",
// //           alignItems: "center"
// //         }}>
// //           <h1
// //             style={{
// //               color: "#ffffff",
// //               fontWeight: "bold",
// //               textAlign: "center",
// //               marginBottom: "10px",
// //               fontSize: "26px",
// //             }}
// //           >
// //             OUR TEAM
// //           </h1>

// //           <button
// //             onClick={() => setIsAddModalOpen(true)}
// //             style={buttonStyle}
// //           >
// //             Add+
// //           </button>
// //         </div>

// //         {/* Team Members Carousel Section */}
// //         <div
// //           style={{
// //             backgroundColor: "white",
// //             margin: "10px",
// //             borderRadius: "20px",
// //             width: "calc(100% - 20px)",
// //           }}
// //         >
// //           {leadershipData.length === 0 ? (
// //             <div style={{ textAlign: "center", padding: "40px", color: "#666" }}>
// //               <p>No team members added yet. Click "Add+" to add your first team member.</p>
// //             </div>
// //           ) : (
// //             <div style={{
// //               padding: "0 10px", // Reduced padding for smaller gaps
// //             }}>
// //               <Slider {...settings}>
// //                 {leadershipData.map((member) => (
// //                   <div key={member.teamId} style={{ padding: "0 8px" }}> {/* Reduced padding for smaller gaps */}
// //                     <LeadershipCardItem
// //                       leader={member}
// //                       onSaveEdit={handleSaveEdit}
// //                       onDelete={handleDeleteMember}
// //                     />
// //                   </div>
// //                 ))}
// //               </Slider>
// //             </div>
// //           )}
// //         </div>
// //       </div>

// //       {/* Add Member Modal */}
// //       {isAddModalOpen && (
// //         <div
// //           style={{
// //             position: "fixed",
// //             top: 0,
// //             left: 0,
// //             right: 0,
// //             bottom: 0,
// //             background: "rgba(0,0,0,0.5)",
// //             zIndex: 1000,
// //             display: "flex",
// //             alignItems: "center",
// //             justifyContent: "center",
// //           }}
// //         >
// //           <div
// //             style={{
// //               maxWidth: "500px",
// //               width: "90%",
// //               background: "white",
// //               borderRadius: "20px",
// //               padding: "30px",
// //               position: "relative",
// //               boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
// //             }}
// //           >
// //             <h2 style={{
// //               textAlign: "center",
// //               marginBottom: "25px",
// //               color: "#b15cd6",
// //               fontWeight: "bold",
// //               fontSize: "24px"
// //             }}>
// //               Add New Team Member
// //             </h2>

// //             <div style={{ marginBottom: "15px" }}>
// //               <input
// //                 type="text"
// //                 placeholder="Name"
// //                 style={modalInputStyle}
// //                 value={newMember.name}
// //                 onChange={(e) => setNewMember({ ...newMember, name: e.target.value })}
// //               />
// //             </div>

// //             <div style={{ marginBottom: "15px" }}>
// //               <input
// //                 type="text"
// //                 placeholder="Designation"
// //                 style={modalInputStyle}
// //                 value={newMember.designation}
// //                 onChange={(e) => setNewMember({ ...newMember, designation: e.target.value })}
// //               />
// //             </div>

// //             <div style={{ marginBottom: "15px" }}>
// //               <textarea
// //                 placeholder="Description"
// //                 style={{ ...modalInputStyle, minHeight: "100px", resize: "vertical" }}
// //                 value={newMember.description}
// //                 onChange={(e) => setNewMember({ ...newMember, description: e.target.value })}
// //               />
// //             </div>

// //             <div style={{ marginBottom: "20px" }}>
// //               <input
// //                 type="file"
// //                 accept="image/*"
// //                 onChange={(e) => setNewMember({ ...newMember, imageFile: e.target.files[0] })}
// //                 style={modalInputStyle}
// //               />
// //             </div>

// //             <div style={{ textAlign: "center", marginTop: "25px" }}>
// //               <button
// //                 onClick={handleAddMember}
// //                 style={modalButtonStyle}
// //               >
// //                 Add Member
// //               </button>
// //               <button
// //                 onClick={() => setIsAddModalOpen(false)}
// //                 style={{ ...modalButtonStyle, backgroundColor: "#6c757d", marginLeft: "10px" }}
// //               >
// //                 Cancel
// //               </button>
// //             </div>
// //           </div>
// //         </div>
// //       )}

// //       <style>
// //         {`
// //     .hide-scrollbar::-webkit-scrollbar {
// //       display: none;
// //       width: 0;
// //       height: 0;
// //     }
    
// //     .hide-scrollbar {
// //       -ms-overflow-style: none;
// //       scrollbar-width: none;
// //     }

// //     .slick-prev:before, .slick-next:before {
// //       display: none !important;
// //     }

// //     .slick-slide {
// //       padding: 10px 0;
// //       height: inherit;
// //     }

// //     .slick-list {
// //       margin: 0 -8px; /* Reduced margin for smaller gaps */
// //       padding: 10px 0;
// //     }

// //     .slick-track {
// //       display: flex;
// //       align-items: stretch;
// //       margin-left: 0;
// //       margin-right: 0;
// //     }
     

// //     /* Ensure consistent card spacing */
// //     .slick-slide > div {
// //       height: 100%;
// //     }

// //     /* Force gap between slides */
// //     .slick-slide {
// //       transition: transform 0.3s ease;
// //     }

// //     /* Custom styling for better visual separation */
// //     .slick-slide:not(.slick-current) {
// //       opacity: 0.95;
// //     }
// //   `}
// //       </style>
// //     </div>
// //   );
// // };

// // // Button Styles
// // const buttonStyle = {
// //   height: "35px",
// //   borderRadius: "5px",
// //   border: "none",
// //   color: "#b15cd6",
// //   fontWeight: "bold",
// //   cursor: "pointer",
// //   width: "80px",
// //   marginLeft: "20px",
// //   marginTop: "-10px",
// //   display: "flex",
// //   alignItems: "center",
// //   justifyContent: "center",
// //   gap: "5px",
// // };

// // const modalInputStyle = {
// //   width: "100%",
// //   padding: "12px",
// //   fontSize: "14px",
// //   border: "1px solid #ddd",
// //   borderRadius: "8px",
// //   fontFamily: "math",
// //   backgroundColor: "#f5f4f4",
// //   outline: "none",
// // };

// // const modalButtonStyle = {
// //   padding: "12px 24px",
// //   backgroundColor: "#b15cd6",
// //   color: "white",
// //   border: "none",
// //   borderRadius: "8px",
// //   cursor: "pointer",
// //   fontWeight: "bold",
// //   fontSize: "14px",
// // };

// // export default LeadershipCard;




// import React, { useState, useEffect, useRef } from "react";
// import { FaEdit, FaSave, FaTrash, FaEllipsisV, FaPlus } from "react-icons/fa";
// import axios from "axios";
// // import "./LeadershipCard.css"; // Optional CSS file

// // ---------- Helper Function ----------
// const getValidImageUrl = (url) => {
//   if (!url) return "/default-image.jpg";
//   try {
//     let decoded = decodeURIComponent(url);
//     if (decoded.startsWith("http://localhost:9000/caterings/http")) {
//       const parts = decoded.split("http://localhost:9000/caterings/");
//       decoded = `http://localhost:9000/caterings/${parts[parts.length - 1]}`;
//     }
//     return decoded;
//   } catch (err) {
//     console.error("Error parsing image URL:", err);
//     return "/default-image.jpg";
//   }
// };

// // ---------- Leadership Card Item ----------
// const LeadershipCardItem = ({ leader, onSaveEdit, onDelete }) => {
//   const [isEditing, setIsEditing] = useState(false);
//   const [editedData, setEditedData] = useState({ ...leader, imageFile: null });
//   const [showEditButtons, setShowEditButtons] = useState(false);
//   const [showThreeDots, setShowThreeDots] = useState(true);

//   const fileInputRef = useRef(null);
//   const threeDotsRef = useRef(null);
//   const editOptionsRef = useRef(null);
//   const timeoutRef = useRef(null);

//   // Click outside detection for each card
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (showEditButtons) {
//         const isEditOptionsClicked = editOptionsRef.current?.contains(event.target);
//         const isThreeDotsClicked = threeDotsRef.current?.contains(event.target);

//         if (!isEditOptionsClicked && !isThreeDotsClicked) {
//           setShowEditButtons(false);
//           setShowThreeDots(true);
//         }
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//       if (timeoutRef.current) clearTimeout(timeoutRef.current);
//     };
//   }, [showEditButtons]);

//   // Auto-hide for each card
//   useEffect(() => {
//     if (showEditButtons) {
//       if (timeoutRef.current) clearTimeout(timeoutRef.current);
//       timeoutRef.current = setTimeout(() => {
//         setShowEditButtons(false);
//         setShowThreeDots(true);
//       }, 5000);
//     }
//   }, [showEditButtons]);

//   const handleThreeDotsClick = () => {
//     setShowThreeDots(false);
//     setShowEditButtons(true);
//   };

//   const handleEditClick = () => {
//     setShowEditButtons(false);
//     setIsEditing(true);
//   };

//   const handleEditToggle = () => {
//     if (isEditing) {
//       onSaveEdit(editedData);
//       setIsEditing(false);
//       setShowThreeDots(true);
//     } else {
//       setIsEditing(true);
//     }
//   };

//   const handleDeleteClick = () => {
//     setShowEditButtons(false);
//     onDelete(leader.teamId);
//   };

//   const handleImageClick = () => {
//     if (isEditing) fileInputRef.current.click();
//   };

//   const handleImageChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         setEditedData((prev) => ({ ...prev, image: reader.result, imageFile: file }));
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   return (
//     <div className="leadership-card" style={styles.card}>
//       {/* Three Dots Button */}
//       {showThreeDots && (
//         <button
//           ref={threeDotsRef}
//           onClick={handleThreeDotsClick}
//           style={styles.threeDotsButton}
//           title="Options"
//         >
//           <FaEllipsisV />
//         </button>
//       )}

//       {/* Edit Options (Edit & Delete buttons) */}
//       {showEditButtons && (
//         <div
//           ref={editOptionsRef}
//           style={styles.editOptions}
//         >
//           <button
//             onClick={handleEditClick}
//             style={styles.editButton}
//           >
//             <FaEdit size={16} /> Edit
//           </button>
//           <button
//             onClick={handleDeleteClick}
//             style={styles.deleteButton}
//           >
//             <FaTrash size={16} /> Delete
//           </button>
//         </div>
//       )}

//       <div style={styles.cardContent}>
//         <img
//           src={getValidImageUrl(editedData.image)}
//           alt={editedData.name}
//           style={{
//             ...styles.memberImage,
//             cursor: isEditing ? "pointer" : "default",
//           }}
//           onClick={handleImageClick}
//         />
//         {isEditing && (
//           <input
//             type="file"
//             accept="image/*"
//             ref={fileInputRef}
//             onChange={handleImageChange}
//             style={{ display: "none" }}
//           />
//         )}

//         {isEditing ? (
//           <div style={styles.editForm}>
//             <div>
//               <input
//                 style={styles.editInput}
//                 value={editedData.name}
//                 onChange={(e) => setEditedData({ ...editedData, name: e.target.value })}
//                 placeholder="Name"
//               />
//               <input
//                 style={styles.editInput}
//                 value={editedData.designation}
//                 onChange={(e) => setEditedData({ ...editedData, designation: e.target.value })}
//                 placeholder="Designation"
//               />
//               <textarea
//                 style={styles.editTextarea}
//                 value={editedData.description}
//                 onChange={(e) => setEditedData({ ...editedData, description: e.target.value })}
//                 placeholder="Description"
//               />
//             </div>
//             <button
//               onClick={handleEditToggle}
//               style={styles.saveButton}
//             >
//               <FaSave size={9} /> Save
//             </button>
//           </div>
//         ) : (
//           <div style={styles.memberInfo}>
//             <div>
//               <h3 style={styles.memberName}>{editedData.name}</h3>
//               <p style={styles.memberDesignation}>{editedData.designation}</p>
//             </div>
//             <p style={styles.memberDescription}>{editedData.description}</p>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// // ---------- Main Leadership Component ----------
// const LeadershipCard = () => {
//   const [leadershipData, setLeadershipData] = useState([]);
//   const [isAddModalOpen, setIsAddModalOpen] = useState(false);
//   const [newMember, setNewMember] = useState({
//     name: "",
//     designation: "",
//     description: "",
//     imageFile: null,
//   });
//   const [vendorId, setVendorId] = useState(null);
//   const [isLoading, setIsLoading] = useState(false);

//   // Scroll container ref
//   const scrollContainerRef = useRef(null);

//   useEffect(() => {
//     const storedVendorId = localStorage.getItem("vendorId");
//     if (storedVendorId) {
//       setVendorId(storedVendorId);
//       fetchTeamMembers(storedVendorId);
//     }
//   }, []);

//   const fetchTeamMembers = async (vendorId) => {
//     const token = localStorage.getItem("authToken");
//     if (!token) return;

//     setIsLoading(true);
//     try {
//       const res = await axios.get(
//         `https://backend.maamaas.com/food/api/adminteam/getall/${vendorId}`,
//         { headers: { Authorization: `Bearer ${token}` } }
//       );

//       const formatted = res.data.map((m) => ({
//         ...m,
//         image: m.image ? getValidImageUrl(m.image) : "/default-image.jpg",
//       }));

//       setLeadershipData(formatted);
//     } catch (err) {
//       console.error(err);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleAddMember = async () => {
//     const token = localStorage.getItem("authToken");
//     const vendorIdNum = Number(localStorage.getItem("vendorId"));

//     if (!newMember.name || !newMember.designation || !newMember.description) {
//       return alert("Please fill all fields.");
//     }

//     const teamData = {
//       name: newMember.name,
//       designation: newMember.designation,
//       description: newMember.description,
//       vendorId: vendorIdNum,
//     };

//     const formData = new FormData();
//     if (newMember.imageFile instanceof File) formData.append("image", newMember.imageFile);
//     formData.append("teamData", new Blob([JSON.stringify(teamData)], { type: "application/json" }));

//     try {
//       await axios.post(
//         `https://backend.maamaas.com/food/api/adminteam/addteam/${vendorIdNum}`,
//         formData,
//         { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } }
//       );
//       alert("Team member added successfully!");
//       setNewMember({ name: "", designation: "", description: "", imageFile: null });
//       setIsAddModalOpen(false);
//       fetchTeamMembers(vendorIdNum);
//     } catch (err) {
//       console.error(err);
//       alert("Failed to add member. Check console.");
//     }
//   };

//   const handleSaveEdit = async (editedMember) => {
//     const token = localStorage.getItem("authToken");
//     const teamData = {
//       name: editedMember.name,
//       designation: editedMember.designation,
//       description: editedMember.description,
//       vendorId,
//     };

//     const formData = new FormData();
//     formData.append("teamData", new Blob([JSON.stringify(teamData)], { type: "application/json" }));
//     if (editedMember.imageFile instanceof File) formData.append("image", editedMember.imageFile);

//     try {
//       await axios.put(
//         `https://backend.maamaas.com/food/api/adminteam/editbyid/${editedMember.teamId}`,
//         formData,
//         { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } }
//       );
//       alert("Member updated successfully!");
//       fetchTeamMembers(vendorId);
//     } catch (err) {
//       console.error(err);
//       alert("Failed to update member. Check console.");
//     }
//   };

//   const handleDeleteMember = async (teamId) => {
//     if (!window.confirm("Are you sure to delete this member?")) return;
//     const token = localStorage.getItem("authToken");
//     try {
//       await axios.delete(
//         `https://backend.maamaas.com/food/api/adminteam/delete/${teamId}`,
//         { headers: { Authorization: `Bearer ${token}` } }
//       );
//       alert("Deleted successfully");
//       fetchTeamMembers(vendorId);
//     } catch (err) {
//       alert("Failed to delete member");
//     }
//   };

//   // Handle scroll
//   const handleScroll = (direction) => {
//     if (scrollContainerRef.current) {
//       const scrollAmount = 250;
//       scrollContainerRef.current.scrollLeft += direction === 'next' ? scrollAmount : -scrollAmount;
//     }
//   };

//   // Calculate cards per row based on screen width
//   const getCardsPerRow = () => {
//     const width = window.innerWidth;
//     if (width < 640) return 1;
//     if (width < 1024) return 2;
//     if (width < 1280) return 3;
//     return 4;
//   };

//   return (
//     <div style={styles.container}>
//       <div style={styles.headerSection}>
//         <div style={styles.headerContent}>
//           <h1 style={styles.headerTitle}>OUR TEAM</h1>
//           <button
//             onClick={() => setIsAddModalOpen(true)}
//             style={styles.addButton}
//           >
//             <FaPlus /> Add+
//           </button>
//         </div>
//       </div>

//       {/* Team Members Section - Using Flex instead of Slick */}
//       <div style={styles.teamSection}>
//         {isLoading ? (
//           <div style={styles.loadingContainer}>
//             <div style={styles.spinner}></div>
//             <p>Loading team members...</p>
//           </div>
//         ) : leadershipData.length === 0 ? (
//           <div style={styles.emptyState}>
//             <p>No team members added yet. Click "Add+" to add your first team member.</p>
//           </div>
//         ) : (
//           <>
//             {/* Scroll buttons for desktop */}
//             {window.innerWidth >= 1024 && leadershipData.length > getCardsPerRow() && (
//               <>
//                 <button 
//                   onClick={() => handleScroll('prev')}
//                   style={styles.scrollButtonLeft}
//                   aria-label="Scroll left"
//                 >
//                   ‹
//                 </button>
//                 <button 
//                   onClick={() => handleScroll('next')}
//                   style={styles.scrollButtonRight}
//                   aria-label="Scroll right"
//                 >
//                   ›
//                 </button>
//               </>
//             )}

//             {/* Cards Container */}
//             <div 
//               ref={scrollContainerRef}
//               style={styles.cardsContainer}
//               className="cards-scroll-container"
//             >
//               {leadershipData.map((member) => (
//                 <div key={member.teamId} style={styles.cardWrapper}>
//                   <LeadershipCardItem
//                     leader={member}
//                     onSaveEdit={handleSaveEdit}
//                     onDelete={handleDeleteMember}
//                   />
//                 </div>
//               ))}
//             </div>

//             {/* Mobile dots indicator */}
//             {window.innerWidth < 1024 && leadershipData.length > 1 && (
//               <div style={styles.dotsContainer}>
//                 {Array.from({ length: Math.ceil(leadershipData.length / getCardsPerRow()) }).map((_, i) => (
//                   <span key={i} style={styles.dot}></span>
//                 ))}
//               </div>
//             )}
//           </>
//         )}
//       </div>

//       {/* Add Member Modal */}
//       {isAddModalOpen && (
//         <div style={styles.modalOverlay}>
//           <div style={styles.modalContent}>
//             <div style={styles.modalHeader}>
//               <h2 style={styles.modalTitle}>Add New Team Member</h2>
//               <button 
//                 onClick={() => setIsAddModalOpen(false)}
//                 style={styles.modalCloseButton}
//                 aria-label="Close"
//               >
//                 ×
//               </button>
//             </div>

//             <div style={styles.modalBody}>
//               <div style={styles.formGroup}>
//                 <input
//                   type="text"
//                   placeholder="Name"
//                   style={styles.modalInput}
//                   value={newMember.name}
//                   onChange={(e) => setNewMember({ ...newMember, name: e.target.value })}
//                 />
//               </div>

//               <div style={styles.formGroup}>
//                 <input
//                   type="text"
//                   placeholder="Designation"
//                   style={styles.modalInput}
//                   value={newMember.designation}
//                   onChange={(e) => setNewMember({ ...newMember, designation: e.target.value })}
//                 />
//               </div>

//               <div style={styles.formGroup}>
//                 <textarea
//                   placeholder="Description"
//                   style={{ ...styles.modalInput, minHeight: "100px", resize: "vertical" }}
//                   value={newMember.description}
//                   onChange={(e) => setNewMember({ ...newMember, description: e.target.value })}
//                 />
//               </div>

//               <div style={styles.formGroup}>
//                 <input
//                   type="file"
//                   accept="image/*"
//                   onChange={(e) => setNewMember({ ...newMember, imageFile: e.target.files[0] })}
//                   style={styles.modalInput}
//                 />
//               </div>
//             </div>

//             <div style={styles.modalFooter}>
//               <button
//                 onClick={handleAddMember}
//                 style={styles.modalPrimaryButton}
//               >
//                 Add Member
//               </button>
//               <button
//                 onClick={() => setIsAddModalOpen(false)}
//                 style={styles.modalSecondaryButton}
//               >
//                 Cancel
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Inline Styles */}
//       <style>{`
//         /* Custom scrollbar for cards container */
//         .cards-scroll-container::-webkit-scrollbar {
//           height: 6px;
//         }
        
//         .cards-scroll-container::-webkit-scrollbar-track {
//           background: #f1f1f1;
//           border-radius: 10px;
//         }
        
//         .cards-scroll-container::-webkit-scrollbar-thumb {
//           background: #b15cd6;
//           border-radius: 10px;
//         }
        
//         .cards-scroll-container::-webkit-scrollbar-thumb:hover {
//           background: #9a4bb8;
//         }
        
//         /* Hide scrollbar on mobile */
//         @media (max-width: 1023px) {
//           .cards-scroll-container {
//             scrollbar-width: none;
//             -ms-overflow-style: none;
//           }
          
//           .cards-scroll-container::-webkit-scrollbar {
//             display: none;
//           }
//         }
        
//         /* Smooth scrolling */
//         .cards-scroll-container {
//           scroll-behavior: smooth;
//         }
//       `}</style>
//     </div>
//   );
// };

// // Styles object
// const styles = {
//   container: {
//     padding: "16px 0",
//     width: "100%",
//     position: "relative",
//   },
//   headerSection: {
//     border: "none",
//     borderRadius: "20px",
//     marginTop: "30px",
//     backgroundColor: "#b15dc6",
//     padding: "20px 0",
//   },
//   headerContent: {
//     display: "flex",
//     width: "100%",
//     padding: "0 16px",
//     paddingTop: "12px",
//     justifyContent: "space-around",
//     alignItems: "center",
//   },
//   headerTitle: {
//     color: "#ffffff",
//     fontWeight: "bold",
//     textAlign: "center",
//     marginBottom: "10px",
//     fontSize: "26px",
//   },
//   addButton: {
//     height: "35px",
//     borderRadius: "5px",
//     border: "none",
//     color: "#b15cd6",
//     backgroundColor: "white",
//     fontWeight: "bold",
//     cursor: "pointer",
//     width: "100px",
//     marginLeft: "20px",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     gap: "5px",
//     fontSize: "14px",
//   },
//   teamSection: {
//     backgroundColor: "white",
//     margin: "10px",
//     borderRadius: "20px",
//     width: "calc(100% - 20px)",
//     padding: "20px 10px",
//     position: "relative",
//     overflow: "hidden",
//   },
//   loadingContainer: {
//     textAlign: "center",
//     padding: "40px",
//     color: "#666",
//   },
//   spinner: {
//     border: "4px solid #f3f3f3",
//     borderTop: "4px solid #b15cd6",
//     borderRadius: "50%",
//     width: "40px",
//     height: "40px",
//     animation: "spin 1s linear infinite",
//     margin: "0 auto 20px",
//   },
//   emptyState: {
//     textAlign: "center",
//     padding: "40px",
//     color: "#666",
//   },
//   cardsContainer: {
//     display: "flex",
//     gap: "20px",
//     padding: "10px",
//     overflowX: "auto",
//     scrollSnapType: "x mandatory",
//     scrollbarWidth: "thin",
//   },
//   cardWrapper: {
//     flex: "0 0 auto",
//     scrollSnapAlign: "start",
//     minWidth: "220px",
//     maxWidth: "250px",
//   },
//   scrollButtonLeft: {
//     position: "absolute",
//     left: "10px",
//     top: "50%",
//     transform: "translateY(-50%)",
//     background: "#b15cd6",
//     color: "white",
//     border: "none",
//     borderRadius: "50%",
//     width: "40px",
//     height: "40px",
//     fontSize: "20px",
//     cursor: "pointer",
//     zIndex: 2,
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
//   },
//   scrollButtonRight: {
//     position: "absolute",
//     right: "10px",
//     top: "50%",
//     transform: "translateY(-50%)",
//     background: "#b15cd6",
//     color: "white",
//     border: "none",
//     borderRadius: "50%",
//     width: "40px",
//     height: "40px",
//     fontSize: "20px",
//     cursor: "pointer",
//     zIndex: 2,
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
//   },
//   dotsContainer: {
//     display: "flex",
//     justifyContent: "center",
//     gap: "8px",
//     marginTop: "20px",
//   },
//   dot: {
//     width: "8px",
//     height: "8px",
//     borderRadius: "50%",
//     backgroundColor: "#ddd",
//   },
//   // Card Item Styles
//   card: {
//     backgroundColor: "white",
//     borderRadius: "20px",
//     padding: "15px",
//     textAlign: "center",
//     width: "100%",
//     height: "280px",
//     boxShadow: "0 4px 16px rgba(0,0,0,0.1)",
//     position: "relative",
//     border: "none",
//     display: "flex",
//     flexDirection: "column",
//   },
//   threeDotsButton: {
//     position: "absolute",
//     top: "8px",
//     right: "8px",
//     background: "transparent",
//     border: "none",
//     color: "#b15cd6",
//     cursor: "pointer",
//     fontSize: "14px",
//     padding: "4px",
//     borderRadius: "50%",
//     zIndex: 5,
//   },
//   editOptions: {
//     position: "absolute",
//     top: "8px",
//     right: "8px",
//     background: "white",
//     border: "1px solid #b15cd6",
//     borderRadius: "8px",
//     padding: "6px",
//     display: "flex",
//     flexDirection: "column",
//     gap: "4px",
//     boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
//     zIndex: 10,
//   },
//   editButton: {
//     background: "transparent",
//     border: "none",
//     color: "#b15cd6",
//     cursor: "pointer",
//     fontSize: "11px",
//     padding: "4px 8px",
//     borderRadius: "4px",
//     textAlign: "left",
//     fontWeight: "500",
//     display: "flex",
//     alignItems: "center",
//     gap: "4px",
//   },
//   deleteButton: {
//     background: "transparent",
//     border: "none",
//     color: "#e53e3e",
//     cursor: "pointer",
//     fontSize: "11px",
//     padding: "4px 8px",
//     borderRadius: "4px",
//     textAlign: "left",
//     fontWeight: "500",
//     display: "flex",
//     alignItems: "center",
//     gap: "4px",
//   },
//   cardContent: {
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "center",
//     height: "100%",
//     justifyContent: "space-between",
//   },
//   memberImage: {
//     width: "70px",
//     height: "70px",
//     borderRadius: "50%",
//     objectFit: "cover",
//     marginBottom: "10px",
//     border: "2px solid #b15dc6",
//   },
//   editForm: {
//     width: "100%",
//     flex: 1,
//     display: "flex",
//     flexDirection: "column",
//     justifyContent: "space-between",
//   },
//   editInput: {
//     marginBottom: "6px",
//     width: "100%",
//     padding: "6px",
//     fontSize: "12px",
//     border: "1px solid #ddd",
//     borderRadius: "4px",
//     fontFamily: "math",
//   },
//   editTextarea: {
//     marginBottom: "6px",
//     width: "100%",
//     padding: "6px",
//     fontSize: "11px",
//     border: "1px solid #ddd",
//     borderRadius: "4px",
//     fontFamily: "math",
//     height: "60px",
//     resize: "none",
//   },
//   saveButton: {
//     background: "#b15cd6",
//     color: "white",
//     border: "none",
//     padding: "6px 12px",
//     borderRadius: "4px",
//     cursor: "pointer",
//     fontWeight: "bold",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     gap: "4px",
//     fontSize: "11px",
//     width: "100%",
//   },
//   memberInfo: {
//     flex: 1,
//     display: "flex",
//     flexDirection: "column",
//     justifyContent: "space-between",
//     width: "100%",
//   },
//   memberName: {
//     fontSize: "14px",
//     fontWeight: "600",
//     color: "#333",
//     marginBottom: "4px",
//     marginTop: "0px",
//     lineHeight: "1.3",
//   },
//   memberDesignation: {
//     fontSize: "12px",
//     fontWeight: "500",
//     color: "#b15dc6",
//     marginBottom: "8px",
//     marginTop: "0px",
//     lineHeight: "1.3",
//   },
//   memberDescription: {
//     fontSize: "11px",
//     color: "#555",
//     lineHeight: "1.3",
//     textAlign: "center",
//     margin: "0",
//     display: "-webkit-box",
//     WebkitLineClamp: "4",
//     WebkitBoxOrient: "vertical",
//     overflow: "hidden",
//     maxHeight: "52px",
//   },
//   // Modal Styles
//   modalOverlay: {
//     position: "fixed",
//     top: 0,
//     left: 0,
//     right: 0,
//     bottom: 0,
//     background: "rgba(0,0,0,0.5)",
//     zIndex: 9999,
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     padding: "20px",
//   },
//   modalContent: {
//     maxWidth: "500px",
//     width: "100%",
//     background: "white",
//     borderRadius: "20px",
//     padding: "30px",
//     position: "relative",
//     boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
//   },
//   modalHeader: {
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "center",
//     marginBottom: "25px",
//   },
//   modalTitle: {
//     textAlign: "center",
//     color: "#b15cd6",
//     fontWeight: "bold",
//     fontSize: "24px",
//     margin: 0,
//   },
//   modalCloseButton: {
//     background: "none",
//     border: "none",
//     fontSize: "28px",
//     cursor: "pointer",
//     color: "#888",
//     lineHeight: 1,
//   },
//   modalBody: {
//     marginBottom: "20px",
//   },
//   formGroup: {
//     marginBottom: "15px",
//   },
//   modalInput: {
//     width: "100%",
//     padding: "12px",
//     fontSize: "14px",
//     border: "1px solid #ddd",
//     borderRadius: "8px",
//     fontFamily: "math",
//     backgroundColor: "#f5f4f4",
//     outline: "none",
//   },
//   modalFooter: {
//     textAlign: "center",
//     marginTop: "25px",
//   },
//   modalPrimaryButton: {
//     padding: "12px 24px",
//     backgroundColor: "#b15cd6",
//     color: "white",
//     border: "none",
//     borderRadius: "8px",
//     cursor: "pointer",
//     fontWeight: "bold",
//     fontSize: "14px",
//   },
//   modalSecondaryButton: {
//     padding: "12px 24px",
//     backgroundColor: "#6c757d",
//     color: "white",
//     border: "none",
//     borderRadius: "8px",
//     cursor: "pointer",
//     marginLeft: "10px",
//     fontSize: "14px",
//   },
// };

// // Add CSS animation for spinner
// const spinnerStyle = document.createElement('style');
// spinnerStyle.textContent = `
//   @keyframes spin {
//     0% { transform: rotate(0deg); }
//     100% { transform: rotate(360deg); }
//   }
// `;
// document.head.appendChild(spinnerStyle);

// export default LeadershipCard;



import React, { useState, useEffect, useRef, useCallback } from "react";
import { FaEdit, FaSave, FaTrash, FaEllipsisV, FaPlus } from "react-icons/fa";
import axios from "axios";

// ---------- Helper Function ----------
const getValidImageUrl = (url) => {
  if (!url) return "/default-image.jpg";
  try {
    let decoded = decodeURIComponent(url);
    if (decoded.startsWith("http://localhost:9000/caterings/http")) {
      const parts = decoded.split("http://localhost:9000/caterings/");
      decoded = `http://localhost:9000/caterings/${parts[parts.length - 1]}`;
    }
    return decoded;
  } catch (err) {
    console.error("Error parsing image URL:", err);
    return "/default-image.jpg";
  }
};

// ---------- Leadership Card Item ----------
const LeadershipCardItem = ({ leader, onSaveEdit, onDelete }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editedData, setEditedData] = useState({ ...leader, imageFile: null });
  const [showEditButtons, setShowEditButtons] = useState(false);
  const [showThreeDots, setShowThreeDots] = useState(true);

  const fileInputRef = useRef(null);
  const threeDotsRef = useRef(null);
  const editOptionsRef = useRef(null);
  const timeoutRef = useRef(null);

  // Click outside detection for each card
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showEditButtons) {
        const isEditOptionsClicked = editOptionsRef.current?.contains(event.target);
        const isThreeDotsClicked = threeDotsRef.current?.contains(event.target);

        if (!isEditOptionsClicked && !isThreeDotsClicked) {
          setShowEditButtons(false);
          setShowThreeDots(true);
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, [showEditButtons]);

  // Auto-hide for each card
  useEffect(() => {
    if (showEditButtons) {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => {
        setShowEditButtons(false);
        setShowThreeDots(true);
      }, 5000);
    }
  }, [showEditButtons]);

  const handleThreeDotsClick = () => {
    setShowThreeDots(false);
    setShowEditButtons(true);
  };

  const handleEditClick = () => {
    setShowEditButtons(false);
    setIsEditing(true);
  };

  const handleEditToggle = () => {
    if (isEditing) {
      onSaveEdit(editedData);
      setIsEditing(false);
      setShowThreeDots(true);
    } else {
      setIsEditing(true);
    }
  };

  const handleDeleteClick = () => {
    setShowEditButtons(false);
    onDelete(leader.teamId);
  };

  const handleImageClick = () => {
    if (isEditing) fileInputRef.current.click();
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setEditedData((prev) => ({ ...prev, image: reader.result, imageFile: file }));
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <div className="leadership-card" style={styles.card}>
      {/* Three Dots Button */}
      {showThreeDots && (
        <button
          ref={threeDotsRef}
          onClick={handleThreeDotsClick}
          style={styles.threeDotsButton}
          title="Options"
        >
          <FaEllipsisV />
        </button>
      )}

      {/* Edit Options (Edit & Delete buttons) */}
      {showEditButtons && (
        <div
          ref={editOptionsRef}
          style={styles.editOptions}
        >
          <button
            onClick={handleEditClick}
            style={styles.editButton}
          >
            <FaEdit size={16} /> Edit
          </button>
          <button
            onClick={handleDeleteClick}
            style={styles.deleteButton}
          >
            <FaTrash size={16} /> Delete
          </button>
        </div>
      )}

      <div style={styles.cardContent}>
        <img
          src={getValidImageUrl(editedData.image)}
          alt={editedData.name}
          style={{
            ...styles.memberImage,
            cursor: isEditing ? "pointer" : "default",
          }}
          onClick={handleImageClick}
        />
        {isEditing && (
          <input
            type="file"
            accept="image/*"
            ref={fileInputRef}
            onChange={handleImageChange}
            style={{ display: "none" }}
          />
        )}

        {isEditing ? (
          <div style={styles.editForm}>
            <div>
              <input
                style={styles.editInput}
                value={editedData.name}
                onChange={(e) => setEditedData({ ...editedData, name: e.target.value })}
                placeholder="Name"
              />
              <input
                style={styles.editInput}
                value={editedData.designation}
                onChange={(e) => setEditedData({ ...editedData, designation: e.target.value })}
                placeholder="Designation"
              />
              <textarea
                style={styles.editTextarea}
                value={editedData.description}
                onChange={(e) => setEditedData({ ...editedData, description: e.target.value })}
                placeholder="Description"
              />
            </div>
            <button
              onClick={handleEditToggle}
              style={styles.saveButton}
            >
              <FaSave size={9} /> Save
            </button>
          </div>
        ) : (
          <div style={styles.memberInfo}>
            <div>
              <h3 style={styles.memberName}>{editedData.name}</h3>
              <p style={styles.memberDesignation}>{editedData.designation}</p>
            </div>
            <p style={styles.memberDescription}>{editedData.description}</p>
          </div>
        )}
      </div>
    </div>
  );
};

// ---------- Main Leadership Component ----------
const LeadershipCard = () => {
  const [leadershipData, setLeadershipData] = useState([]);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [newMember, setNewMember] = useState({
    name: "",
    designation: "",
    description: "",
    imageFile: null,
  });
  const [vendorId, setVendorId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  
  // Refs
  const scrollContainerRef = useRef(null);
  const autoScrollIntervalRef = useRef(null);
  const cardWidthRef = useRef(250); // Default card width including margin

  useEffect(() => {
    const storedVendorId = localStorage.getItem("vendorId");
    if (storedVendorId) {
      setVendorId(storedVendorId);
      fetchTeamMembers(storedVendorId);
    }
    
    // Start auto-scroll
    startAutoScroll();
    
    // Cleanup on unmount
    return () => {
      if (autoScrollIntervalRef.current) {
        clearInterval(autoScrollIntervalRef.current);
      }
    };
  }, []);

  // Restart auto-scroll when leadershipData changes
  useEffect(() => {
    if (leadershipData.length > 0) {
      if (autoScrollIntervalRef.current) {
        clearInterval(autoScrollIntervalRef.current);
      }
      startAutoScroll();
    }
  }, [leadershipData]);

  const fetchTeamMembers = async (vendorId) => {
    const token = localStorage.getItem("authToken");
    if (!token) return;

    setIsLoading(true);
    try {
      const res = await axios.get(
        `https://backend.maamaas.com/food/api/adminteam/getall/${vendorId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const formatted = res.data.map((m) => ({
        ...m,
        image: m.image ? getValidImageUrl(m.image) : "/default-image.jpg",
      }));

      setLeadershipData(formatted);
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  // Calculate cards per row based on screen width
  const getCardsPerRow = () => {
    const width = window.innerWidth;
    if (width < 900) return 1;
    if (width < 1100) return 2;
    if (width < 1600) return 3;
    return 4;
  };

  // Calculate card width including gap
  const getCardWidth = () => {
    const cardsPerRow = getCardsPerRow();
    const containerWidth = scrollContainerRef.current?.offsetWidth || 1200;
    const gap = 20;
    return (containerWidth - (gap * (cardsPerRow - 1))) / cardsPerRow;
  };

  // Handle scroll to specific slide
  const scrollToSlide = (slideIndex) => {
    if (scrollContainerRef.current && leadershipData.length > 0) {
      const cardsPerRow = getCardsPerRow();
      const slideWidth = getCardWidth() + 20; // card width + gap
      const maxSlide = Math.ceil(leadershipData.length / cardsPerRow) - 1;
      
      const targetSlide = Math.min(slideIndex, maxSlide);
      setCurrentSlide(targetSlide);
      
      scrollContainerRef.current.scrollTo({
        left: targetSlide * slideWidth * cardsPerRow,
        behavior: 'smooth'
      });
    }
  };

  // Auto-scroll function
  const startAutoScroll = () => {
    if (autoScrollIntervalRef.current) {
      clearInterval(autoScrollIntervalRef.current);
    }

    if (leadershipData.length <= getCardsPerRow()) {
      return; // Don't auto-scroll if all cards fit in one view
    }

    autoScrollIntervalRef.current = setInterval(() => {
      const cardsPerRow = getCardsPerRow();
      const totalSlides = Math.ceil(leadershipData.length / cardsPerRow);
      
      if (currentSlide < totalSlides - 1) {
        scrollToSlide(currentSlide + 1);
      } else {
        scrollToSlide(0); // Go back to first slide
      }
    }, 3000); // Change slide every 3 seconds
  };

  // Handle manual scroll
  const handleScroll = (direction) => {
    if (autoScrollIntervalRef.current) {
      clearInterval(autoScrollIntervalRef.current);
    }
    
    const cardsPerRow = getCardsPerRow();
    const totalSlides = Math.ceil(leadershipData.length / cardsPerRow);
    
    let newSlide;
    if (direction === 'next') {
      newSlide = currentSlide >= totalSlides - 1 ? 0 : currentSlide + 1;
    } else {
      newSlide = currentSlide <= 0 ? totalSlides - 1 : currentSlide - 1;
    }
    
    scrollToSlide(newSlide);
    
    // Restart auto-scroll after manual interaction
    setTimeout(() => startAutoScroll(), 5000);
  };

  // Handle scroll container scroll event
  const handleContainerScroll = () => {
    if (scrollContainerRef.current) {
      const scrollLeft = scrollContainerRef.current.scrollLeft;
      const cardsPerRow = getCardsPerRow();
      const slideWidth = getCardWidth() + 20;
      const newSlide = Math.round(scrollLeft / (slideWidth * cardsPerRow));
      setCurrentSlide(newSlide);
    }
  };

  const handleAddMember = async () => {
    const token = localStorage.getItem("authToken");
    const vendorIdNum = Number(localStorage.getItem("vendorId"));

    if (!newMember.name || !newMember.designation || !newMember.description) {
      return alert("Please fill all fields.");
    }

    const teamData = {
      name: newMember.name,
      designation: newMember.designation,
      description: newMember.description,
      vendorId: vendorIdNum,
    };

    const formData = new FormData();
    if (newMember.imageFile instanceof File) formData.append("image", newMember.imageFile);
    formData.append("teamData", new Blob([JSON.stringify(teamData)], { type: "application/json" }));

    try {
      await axios.post(
        `https://backend.maamaas.com/food/api/adminteam/addteam/${vendorIdNum}`,
        formData,
        { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } }
      );
      alert("Team member added successfully!");
      setNewMember({ name: "", designation: "", description: "", imageFile: null });
      setIsAddModalOpen(false);
      fetchTeamMembers(vendorIdNum);
    } catch (err) {
      console.error(err);
      alert("Failed to add member. Check console.");
    }
  };

  const handleSaveEdit = async (editedMember) => {
    const token = localStorage.getItem("authToken");
    const teamData = {
      name: editedMember.name,
      designation: editedMember.designation,
      description: editedMember.description,
      vendorId,
    };

    const formData = new FormData();
    formData.append("teamData", new Blob([JSON.stringify(teamData)], { type: "application/json" }));
    if (editedMember.imageFile instanceof File) formData.append("image", editedMember.imageFile);

    try {
      await axios.put(
        `https://backend.maamaas.com/food/api/adminteam/editbyid/${editedMember.teamId}`,
        formData,
        { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } }
      );
      alert("Member updated successfully!");
      fetchTeamMembers(vendorId);
    } catch (err) {
      console.error(err);
      alert("Failed to update member. Check console.");
    }
  };

  const handleDeleteMember = async (teamId) => {
    if (!window.confirm("Are you sure to delete this member?")) return;
    const token = localStorage.getItem("authToken");
    try {
      await axios.delete(
        `https://backend.maamaas.com/food/api/adminteam/delete/${teamId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      alert("Deleted successfully");
      fetchTeamMembers(vendorId);
    } catch (err) {
      alert("Failed to delete member");
    }
  };

  // Get total slides count
  const getTotalSlides = () => {
    const cardsPerRow = getCardsPerRow();
    return Math.ceil(leadershipData.length / cardsPerRow);
  };

  return (
    <div style={styles.container}>
      <div style={styles.headerSection}>
        <div style={styles.headerContent}>
          <h1 style={styles.headerTitle}>OUR TEAM</h1>
          <button
            onClick={() => setIsAddModalOpen(true)}
            style={styles.addButton}
          >
            <FaPlus /> Add+
          </button>
        </div>
      </div>

      {/* Team Members Section */}
      <div style={styles.teamSection}>
        {isLoading ? (
          <div style={styles.loadingContainer}>
            <div style={styles.spinner}></div>
            <p>Loading team members...</p>
          </div>
        ) : leadershipData.length === 0 ? (
          <div style={styles.emptyState}>
            <p>No team members added yet. Click "Add+" to add your first team member.</p>
          </div>
        ) : (
          <>
            {/* Scroll buttons for desktop */}
            {getTotalSlides() > 1 && (
              <>
                {/* <button 
                  onClick={() => handleScroll('prev')}
                  style={styles.scrollButtonLeft}
                  aria-label="Scroll left"
                >
                  ‹
                </button>
                <button 
                  onClick={() => handleScroll('next')}
                  style={styles.scrollButtonRight}
                  aria-label="Scroll right"
                >
                  ›
                </button> */}
              </>
            )}

            {/* Cards Container */}
            <div 
              ref={scrollContainerRef}
              style={styles.cardsContainer}
              className="cards-scroll-container"
              onScroll={handleContainerScroll}
            >
              {leadershipData.map((member) => (
                <div 
                  key={member.teamId} 
                  style={{
                    ...styles.cardWrapper,
                    width: `calc(${100 / getCardsPerRow()}% - 15px)`,
                    minWidth: "220px",
                    maxWidth: "280px",
                  }}
                >
                  <LeadershipCardItem
                    leader={member}
                    onSaveEdit={handleSaveEdit}
                    onDelete={handleDeleteMember}
                  />
                </div>
              ))}
            </div>

            {/* Slide indicators */}
            {getTotalSlides() > 1 && (
              <div style={styles.dotsContainer}>
                {Array.from({ length: getTotalSlides() }).map((_, i) => (
                  <button
                    key={i}
                    onClick={() => scrollToSlide(i)}
                    style={{
                      ...styles.dot,
                      backgroundColor: i === currentSlide ? "#b15cd6" : "#ddd",
                      transform: i === currentSlide ? "scale(1.2)" : "scale(1)",
                    }}
                    aria-label={`Go to slide ${i + 1}`}
                  />
                ))}
              </div>
            )}
          </>
        )}
      </div>

      {/* Add Member Modal */}
      {isAddModalOpen && (
        <div style={styles.modalOverlay}>
          <div style={styles.modalContent}>
            <div style={styles.modalHeader}>
              <h2 style={styles.modalTitle}>Add New Team Member</h2>
              <button 
                onClick={() => setIsAddModalOpen(false)}
                style={styles.modalCloseButton}
                aria-label="Close"
              >
                ×
              </button>
            </div>

            <div style={styles.modalBody}>
              <div style={styles.formGroup}>
                <input
                  type="text"
                  placeholder="Name"
                  style={styles.modalInput}
                  value={newMember.name}
                  onChange={(e) => setNewMember({ ...newMember, name: e.target.value })}
                />
              </div>

              <div style={styles.formGroup}>
                <input
                  type="text"
                  placeholder="Designation"
                  style={styles.modalInput}
                  value={newMember.designation}
                  onChange={(e) => setNewMember({ ...newMember, designation: e.target.value })}
                />
              </div>

              <div style={styles.formGroup}>
                <textarea
                  placeholder="Description"
                  style={{ ...styles.modalInput, minHeight: "100px", resize: "vertical" }}
                  value={newMember.description}
                  onChange={(e) => setNewMember({ ...newMember, description: e.target.value })}
                />
              </div>

              <div style={styles.formGroup}>
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => setNewMember({ ...newMember, imageFile: e.target.files[0] })}
                  style={styles.modalInput}
                />
              </div>
            </div>

            <div style={styles.modalFooter}>
              <button
                onClick={handleAddMember}
                style={styles.modalPrimaryButton}
              >
                Add Member
              </button>
              <button
                onClick={() => setIsAddModalOpen(false)}
                style={styles.modalSecondaryButton}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Inline Styles */}
      <style>{`
        /* Animation for spinner */
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        
        /* Custom scrollbar for cards container */
        .cards-scroll-container::-webkit-scrollbar {
          height: 6px;
        }
        
        .cards-scroll-container::-webkit-scrollbar-track {
          background: #f1f1f1;
          border-radius: 10px;
        }
        
        .cards-scroll-container::-webkit-scrollbar-thumb {
          background: #b15cd6;
          border-radius: 10px;
        }
        
        .cards-scroll-container::-webkit-scrollbar-thumb:hover {
          background: #9a4bb8;
        }
        
        /* Hide scrollbar on mobile */
        @media (max-width: 899px) {
          .cards-scroll-container {
            scrollbar-width: none;
            -ms-overflow-style: none;
            overflow-x: auto;
            justify-content: flex-start;
          }
          
          .cards-scroll-container::-webkit-scrollbar {
            display: none;
          }
        }
        
        /* Smooth scrolling */
        .cards-scroll-container {
          scroll-behavior: smooth;
          scroll-snap-type: x mandatory;
        }
        
        /* Responsive card layout */
        @media (max-width: 899px) {
          .cards-scroll-container .card-wrapper {
            scroll-snap-align: start;
            flex: 0 0 100%;
          }
        }
        
        @media (min-width: 900px) and (max-width: 1099px) {
          .cards-scroll-container .card-wrapper {
            scroll-snap-align: start;
            flex: 0 0 calc(50% - 10px);
          }
        }
        
        @media (min-width: 1100px) and (max-width: 1599px) {
          .cards-scroll-container .card-wrapper {
            scroll-snap-align: start;
            flex: 0 0 calc(33.333% - 14px);
          }
        }
        
        @media (min-width: 1600px) {
          .cards-scroll-container .card-wrapper {
            scroll-snap-align: start;
            flex: 0 0 calc(25% - 15px);
          }
        }
        
        /* Pause auto-scroll on hover */
        .cards-scroll-container:hover {
          animation-play-state: paused;
        }
      `}</style>
    </div>
  );
};

// Styles object
const styles = {
  container: {
    padding: "16px 0",
    width: "100%",
    position: "relative",
  },
  headerSection: {
    border: "none",
    borderRadius: "20px",
    marginTop: "30px",
    backgroundColor: "#b15dc6",
    padding: "20px 0",
  },
  headerContent: {
    display: "flex",
    width: "100%",
    padding: "0 16px",
    paddingTop: "12px",
    justifyContent: "space-around",
    alignItems: "center",
  },
  headerTitle: {
    color: "#ffffff",
    fontWeight: "bold",
    textAlign: "center",
    marginBottom: "10px",
    fontSize: "26px",
  },
  addButton: {
    height: "35px",
    borderRadius: "5px",
    border: "none",
    color: "#b15cd6",
    backgroundColor: "white",
    fontWeight: "bold",
    cursor: "pointer",
    width: "100px",
    marginLeft: "20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "5px",
    fontSize: "14px",
  },
  teamSection: {
    backgroundColor: "white",
    margin: "10px",
    borderRadius: "20px",
    width: "calc(100% - 20px)",
    padding: "20px 10px",
    position: "relative",
    overflow: "hidden",
  },
  loadingContainer: {
    textAlign: "center",
    padding: "40px",
    color: "#666",
  },
  spinner: {
    border: "4px solid #f3f3f3",
    borderTop: "4px solid #b15cd6",
    borderRadius: "50%",
    width: "40px",
    height: "40px",
    animation: "spin 1s linear infinite",
    margin: "0 auto 20px",
  },
  emptyState: {
    textAlign: "center",
    padding: "40px",
    color: "#666",
  },
  cardsContainer: {
    display: "flex",
    gap: "20px",
    padding: "10px",
    overflowX: "auto",
    scrollbarWidth: "thin",
    flexWrap: "nowrap",
  },
  cardWrapper: {
    flexShrink: 0,
    transition: "all 0.3s ease",
  },
  scrollButtonLeft: {
    position: "absolute",
    left: "10px",
    top: "50%",
    transform: "translateY(-50%)",
    background: "#b15cd6",
    color: "white",
    border: "none",
    borderRadius: "50%",
    width: "40px",
    height: "40px",
    fontSize: "20px",
    cursor: "pointer",
    zIndex: 2,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
    opacity: 0.8,
    transition: "opacity 0.3s",
  },
  scrollButtonRight: {
    position: "absolute",
    right: "10px",
    top: "50%",
    transform: "translateY(-50%)",
    background: "#b15cd6",
    color: "white",
    border: "none",
    borderRadius: "50%",
    width: "40px",
    height: "40px",
    fontSize: "20px",
    cursor: "pointer",
    zIndex: 2,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
    opacity: 0.8,
    transition: "opacity 0.3s",
  },
  dotsContainer: {
    display: "flex",
    justifyContent: "center",
    gap: "10px",
    marginTop: "20px",
    flexWrap: "wrap",
  },
  dot: {
    width: "12px",
    height: "12px",
    borderRadius: "50%",
    border: "none",
    cursor: "pointer",
    transition: "all 0.3s ease",
    padding: 0,
  },
  // Card Item Styles
  card: {
    backgroundColor: "white",
    borderRadius: "20px",
    padding: "15px",
    textAlign: "center",
    width: "100%",
    height: "280px",
    boxShadow: "0 4px 16px rgba(0,0,0,0.1)",
    position: "relative",
    border: "none",
    display: "flex",
    flexDirection: "column",
  },
  threeDotsButton: {
    position: "absolute",
    top: "8px",
    right: "8px",
    background: "transparent",
    border: "none",
    color: "#b15cd6",
    cursor: "pointer",
    fontSize: "14px",
    padding: "4px",
    borderRadius: "50%",
    zIndex: 5,
  },
  editOptions: {
    position: "absolute",
    top: "8px",
    right: "8px",
    background: "white",
    border: "1px solid #b15cd6",
    borderRadius: "8px",
    padding: "6px",
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
    zIndex: 10,
  },
  editButton: {
    background: "transparent",
    border: "none",
    color: "#b15cd6",
    cursor: "pointer",
    fontSize: "11px",
    padding: "4px 8px",
    borderRadius: "4px",
    textAlign: "left",
    fontWeight: "500",
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },
  deleteButton: {
    background: "transparent",
    border: "none",
    color: "#e53e3e",
    cursor: "pointer",
    fontSize: "11px",
    padding: "4px 8px",
    borderRadius: "4px",
    textAlign: "left",
    fontWeight: "500",
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },
  cardContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    height: "100%",
    justifyContent: "space-between",
  },
  memberImage: {
    width: "70px",
    height: "70px",
    borderRadius: "50%",
    objectFit: "cover",
    marginBottom: "10px",
    border: "2px solid #b15dc6",
  },
  editForm: {
    width: "100%",
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  editInput: {
    marginBottom: "6px",
    width: "100%",
    padding: "6px",
    fontSize: "12px",
    border: "1px solid #ddd",
    borderRadius: "4px",
    fontFamily: "math",
  },
  editTextarea: {
    marginBottom: "6px",
    width: "100%",
    padding: "6px",
    fontSize: "11px",
    border: "1px solid #ddd",
    borderRadius: "4px",
    fontFamily: "math",
    height: "60px",
    resize: "none",
  },
  saveButton: {
    background: "#b15cd6",
    color: "white",
    border: "none",
    padding: "6px 12px",
    borderRadius: "4px",
    cursor: "pointer",
    fontWeight: "bold",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "4px",
    fontSize: "11px",
    width: "100%",
  },
  memberInfo: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    width: "100%",
  },
  memberName: {
    fontSize: "14px",
    fontWeight: "600",
    color: "#333",
    marginBottom: "4px",
    marginTop: "0px",
    lineHeight: "1.3",
  },
  memberDesignation: {
    fontSize: "12px",
    fontWeight: "500",
    color: "#b15dc6",
    marginBottom: "8px",
    marginTop: "0px",
    lineHeight: "1.3",
  },
  memberDescription: {
    fontSize: "11px",
    color: "#555",
    lineHeight: "1.3",
    textAlign: "center",
    margin: "0",
    display: "-webkit-box",
    WebkitLineClamp: "4",
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    maxHeight: "52px",
  },
  // Modal Styles
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: "rgba(0,0,0,0.5)",
    zIndex: 9999,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "20px",
  },
  modalContent: {
    maxWidth: "500px",
    width: "100%",
    background: "white",
    borderRadius: "20px",
    padding: "30px",
    position: "relative",
    boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
  },
  modalHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "25px",
  },
  modalTitle: {
    textAlign: "center",
    color: "#b15cd6",
    fontWeight: "bold",
    fontSize: "24px",
    margin: 0,
  },
  modalCloseButton: {
    background: "none",
    border: "none",
    fontSize: "28px",
    cursor: "pointer",
    color: "#888",
    lineHeight: 1,
  },
  modalBody: {
    marginBottom: "20px",
  },
  formGroup: {
    marginBottom: "15px",
  },
  modalInput: {
    width: "100%",
    padding: "12px",
    fontSize: "14px",
    border: "1px solid #ddd",
    borderRadius: "8px",
    fontFamily: "math",
    backgroundColor: "#f5f4f4",
    outline: "none",
  },
  modalFooter: {
    textAlign: "center",
    marginTop: "25px",
  },
  modalPrimaryButton: {
    padding: "12px 24px",
    backgroundColor: "#b15cd6",
    color: "white",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    fontWeight: "bold",
    fontSize: "14px",
  },
  modalSecondaryButton: {
    padding: "12px 24px",
    backgroundColor: "#6c757d",
    color: "white",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    marginLeft: "10px",
    fontSize: "14px",
  },
};

export default LeadershipCard;